function hideTemplateVariantInputs() {
  document
    .querySelectorAll('input[id*="-template-"][type="radio"], input[id*="-template-"][type="checkbox"]')
    .forEach(function (el) {
      // Accessibility remediation: Shopify section ids embed `template--…`, so collection/search facet
      // radios and checkboxes match `id*="-template-"` even though they are not PDP variant-picker
      // duplicates. Hiding them removed keyboard and AT access (WCAG 2.2 2.1.1 Keyboard (A), 4.1.2 Name, Role, Value (A)).
      // Accessibility remediation: PDP/quick-buy `<variant-picker>` option radios are not “duplicate” controls: do not
      // apply the template duplicate-hider’s `aria-hidden` to normal picker radios (WCAG 2.2 2.1.1 Keyboard (A), 4.1.2).
      // Exception: URL/combined-product pickers mark one `data-a11y-variant-url-nav` radio for `theme.js` while other
      // options are links — that lone input is `aria-hidden` (not a real radio group for AT). Checked radios stay
      // `tabindex="-1"` so they are not an extra tab stop when the visible swatch is non-interactive (2.4.3 Focus Order (A)).
      if (el.closest('form[is="facet-form"]')) {
        if (el.getAttribute('aria-hidden') === 'true') {
          el.removeAttribute('aria-hidden');
        }
        if (el.getAttribute('tabindex') === '-1') {
          el.removeAttribute('tabindex');
        }
        return;
      }
      if (el.closest('variant-picker')) {
        // Accessibility remediation: Combined-product / URL-update pickers keep one `radio` for `theme.js` (`:checked`,
        // change events) but other options are `<a>` links; that lone control is not a real radio group for AT.
        if (el.dataset.a11yVariantUrlNav === 'true') {
          el.setAttribute('aria-hidden', 'true');
          el.setAttribute('tabindex', '-1');
          return;
        }
        if (el.getAttribute('aria-hidden') === 'true') {
          el.removeAttribute('aria-hidden');
        }
        // Accessibility remediation: Quick-buy keeps every variant `radio` in the sequential tab order (do not set `tabindex="-1"` on the checked input). Otherwise the selected control is skipped when tabbing back from title/close/checkout, and the trap’s initial focus can land on the first `input` instead of close (WCAG 2.2 2.1.1 Keyboard (A), 2.4.3 Focus Order (A)).
        if (el.closest('quick-buy-drawer')) {
          if (el.type === 'radio' && el.getAttribute('tabindex') === '-1') {
            el.removeAttribute('tabindex');
          }
          var qbDrawer = el.closest('quick-buy-drawer');
          if (qbDrawer) {
            fixVariantPickerOptionControlNames(qbDrawer);
            fixVariantPickerThumbnailDecorativeAlts(qbDrawer);
          }
          return;
        }
        // Accessibility remediation: A single radio in a group (e.g. one-size option) must stay focusable; `tabindex="-1"` on the only checked input removes the entire dimension from Tab order (WCAG 2.2 2.1.1 Keyboard (A)).
        if (el.type === 'radio') {
          var vp = el.closest('variant-picker');
          if (vp) {
            var fid = el.getAttribute('form') || '';
            var groupSize = 0;
            Array.from(vp.querySelectorAll('input[type="radio"]')).forEach(function (r) {
              if (r.name === el.name && (r.getAttribute('form') || '') === fid && r.dataset.a11yVariantUrlNav !== 'true') {
                groupSize += 1;
              }
            });
            if (groupSize <= 1) {
              if (el.getAttribute('tabindex') === '-1') {
                el.removeAttribute('tabindex');
              }
              return;
            }
          }
        }
        // Accessibility remediation: Checked = current selection; remove from tab order. Unchecked options remain focusable
        // so the group is still operable; non-radio controls under variant-picker (if any) get stray -1 removed only.
        if (el.type === 'radio') {
          if (el.checked) {
            el.setAttribute('tabindex', '-1');
          } else if (el.getAttribute('tabindex') === '-1') {
            el.removeAttribute('tabindex');
          }
        } else if (el.getAttribute('tabindex') === '-1') {
          el.removeAttribute('tabindex');
        }
        return;
      }
      el.setAttribute('aria-hidden', 'true');
      el.setAttribute('tabindex', '-1');
    });
}

// Accessibility remediation: Facet color swatches use native `<label for>` only (no `aria-label`); see
// `stripFacetOptionControlAriaLabels`. Variant-picker / quick-buy / card swatches use short `aria-label` on the input
// and `aria-hidden` on the label so Tab/arrow traversal does not read long generated `id`/`name` strings (WCAG 2.2
// 4.1.2 Name, Role, Value (A); 1.3.1 Info and Relationships (A)).
function stripFacetOptionControlAriaLabels(root) {
  var scope = root && root.querySelectorAll ? root : document;
  scope
    .querySelectorAll('form[is="facet-form"] input.sr-only[type="checkbox"][id^="option-value-"]')
    .forEach(function (input) {
      if (!input.id || !input.hasAttribute('aria-label')) {
        return;
      }
      var associated =
        scope.querySelector('label[for="' + CSS.escape(input.id) + '"]') ||
        (input.nextElementSibling && input.nextElementSibling.tagName === 'LABEL'
          ? input.nextElementSibling
          : null);
      if (!associated || associated.getAttribute('aria-hidden') === 'true') {
        return;
      }
      if (!(associated.textContent || '').trim()) {
        return;
      }
      input.removeAttribute('aria-label');
    });
}

function findOptionValueLabel(input, scope) {
  if (!input || !input.id) {
    return null;
  }
  return (
    scope.querySelector('label[for="' + CSS.escape(input.id) + '"]') ||
    (input.nextElementSibling && input.nextElementSibling.tagName === 'LABEL'
      ? input.nextElementSibling
      : null)
  );
}

function readVariantPickerOptionLabelText(label, input) {
  if (input && (input.getAttribute('aria-label') || '').trim()) {
    return (input.getAttribute('aria-label') || '').replace(/\s+/g, ' ').trim();
  }
  if (!label) {
    return '';
  }
  var srOnly = label.querySelector('.sr-only');
  if (srOnly && (srOnly.textContent || '').trim()) {
    return (srOnly.textContent || '').replace(/\s+/g, ' ').trim();
  }
  var span = label.querySelector('span');
  if (span && (span.textContent || '').trim()) {
    return (span.textContent || '').replace(/\s+/g, ' ').trim();
  }
  return (label.textContent || '').replace(/\s+/g, ' ').trim();
}

function fixVariantPickerOptionControlNames(root) {
  var scope = root && root.querySelectorAll ? root : document;
  scope
    .querySelectorAll(
      'variant-picker input.sr-only[type="radio"][id^="option-value-"],' +
        'fieldset.product-card__swatch-list input.sr-only[type="radio"][id^="option-value-"]'
    )
    .forEach(function (input) {
      if (input.dataset.a11yVariantUrlNav === 'true' || input.getAttribute('aria-hidden') === 'true') {
        return;
      }
      var label = findOptionValueLabel(input, scope);
      if (!label) {
        return;
      }
      var text = readVariantPickerOptionLabelText(label, input);
      if (!text) {
        return;
      }
      if (input.disabled && text.indexOf('(unavailable)') === -1) {
        text += ' (unavailable)';
      }
      label.setAttribute('aria-hidden', 'true');
      if (input.getAttribute('aria-label') !== text) {
        input.setAttribute('aria-label', text);
      }
    });
}

// Accessibility remediation: Variant-picker thumbnail options pair `sr-only` option text with variant preview
// images that default to product-title `alt`, so screen readers announce “Bisque” then “The Mirror”. Empty `alt`
// when the label already names the control (WCAG 2.2 1.1.1 Non-text Content (A), 4.1.2 Name, Role, Value (A)).
function fixVariantPickerThumbnailDecorativeAlts(root) {
  var scope = root && root.querySelectorAll ? root : document;
  scope.querySelectorAll('variant-picker .thumbnail-swatch').forEach(function (row) {
    var srOnly = row.querySelector('.sr-only');
    if (!srOnly || !(srOnly.textContent || '').trim()) {
      return;
    }
    row.querySelectorAll('img').forEach(function (img) {
      if (img.getAttribute('alt') !== '') {
        img.setAttribute('alt', '');
      }
    });
  });
}

function applyVariantPickerOptionA11yFixes(root) {
  fixVariantPickerOptionControlNames(root);
  fixVariantPickerThumbnailDecorativeAlts(root);
  stripFacetOptionControlAriaLabels(root);
}

// Accessibility remediation: `aria-live="polite"` on `<quick-buy-drawer>` makes the screen reader re-read the entire
// sheet (close, title, price, all option names concatenated) whenever `product-rerender` swaps markup on variant
// change — not just the focused radio. Remove live region from the dialog; price/selection are already exposed on
// controls and legend (WCAG 2.2 4.1.3 Status Messages (A)).
function fixQuickBuyDrawerLiveRegion() {
  if (typeof document === 'undefined') {
    return;
  }
  document.querySelectorAll('quick-buy-drawer').forEach(function (drawer) {
    if (drawer.hasAttribute('aria-live')) {
      drawer.removeAttribute('aria-live');
    }
    if (drawer.getAttribute('role') === 'region') {
      drawer.removeAttribute('role');
    }
  });
}

// Accessibility remediation: Clear (type="reset") in .search-input stays opacity-hidden when empty but was still
// keyboard-focusable, causing a tab stop with no visible focus. On bind we set disabled from the current value (no
// Liquid change required); then toggle on input/change and after form reset. WCAG 2.4.7 Focus Visible (AA), 2.4.3 Focus Order (A).
function syncSearchClearButtonDisabled(input) {
  var wrap = input.closest('.search-input');
  if (!wrap) {
    return;
  }
  var resetBtn = wrap.querySelector('button[type="reset"]');
  if (!resetBtn) {
    return;
  }
  resetBtn.disabled = (input.value || '').trim().length === 0;
}

function bindSearchClearButtonA11y(wrap) {
  var input = wrap.querySelector('input:not([type="hidden"])');
  var resetBtn = wrap.querySelector('button[type="reset"]');
  if (!input || !resetBtn) {
    return;
  }
  syncSearchClearButtonDisabled(input);
  if (input.dataset.a11ySearchClearBound === '1') {
    return;
  }
  input.dataset.a11ySearchClearBound = '1';
  input.addEventListener('input', function () {
    syncSearchClearButtonDisabled(input);
  });
  input.addEventListener('change', function () {
    syncSearchClearButtonDisabled(input);
  });
  var form = wrap.closest('form');
  if (form && form.dataset.a11ySearchFormResetBound !== '1') {
    form.dataset.a11ySearchFormResetBound = '1';
    form.addEventListener('reset', function () {
      window.setTimeout(function () {
        form.querySelectorAll('.search-input').forEach(function (w) {
          var inp = w.querySelector('input:not([type="hidden"])');
          if (inp) {
            syncSearchClearButtonDisabled(inp);
          }
        });
      }, 0);
    });
  }
}

function initSearchClearButtons(root) {
  var scope = root || document;
  scope.querySelectorAll('.search-input').forEach(bindSearchClearButtonA11y);
}

// Accessibility remediation: Search drawer exposes only aria-label + placeholder, with no persistent visible label.
// Insert a real <label for="..."> before .search-input (scoped to search-drawer), reuse aria-label text for i18n parity,
// then drop aria-label to avoid a duplicated name. WCAG 2.2 3.3.2 Labels or Instructions (A), 1.3.1 Info and Relationships (A).
function ensureSearchDrawerVisibleLabel(searchInputWrap) {
  if (!searchInputWrap || !searchInputWrap.closest('search-drawer')) {
    return;
  }
  var form = searchInputWrap.closest('form[role="search"]');
  if (!form) {
    return;
  }
  var input = searchInputWrap.querySelector('input[type="search"], input[name="q"]');
  if (!input || input.type === 'hidden') {
    return;
  }
  if (input.dataset.a11ySearchDrawerVisibleLabel === '1') {
    return;
  }

  var inputId = input.id;
  if (inputId) {
    var labels = form.querySelectorAll('label[for]');
    var already = Array.prototype.some.call(labels, function (lab) {
      return lab.getAttribute('for') === inputId && !lab.classList.contains('sr-only');
    });
    if (already) {
      input.dataset.a11ySearchDrawerVisibleLabel = '1';
      return;
    }
  } else {
    var baseId = 'a11y-search-drawer-query';
    var candidate = baseId;
    var n = 0;
    while (document.getElementById(candidate)) {
      n += 1;
      candidate = baseId + '-' + n;
    }
    input.id = candidate;
    inputId = input.id;
  }

  var labelText = (input.getAttribute('aria-label') || '').trim();
  if (!labelText) {
    labelText = (input.getAttribute('placeholder') || '').trim();
  }
  if (!labelText) {
    labelText = 'Search';
  }

  var label = document.createElement('label');
  label.className = 'a11y-search-drawer-visible-label';
  label.setAttribute('for', inputId);
  label.textContent = labelText;

  form.insertBefore(label, searchInputWrap);
  input.removeAttribute('aria-label');
  input.dataset.a11ySearchDrawerVisibleLabel = '1';
}

function initSearchDrawerVisibleLabels(root) {
  var scope = root || document;
  scope.querySelectorAll('search-drawer form[role="search"] .search-input').forEach(ensureSearchDrawerVisibleLabel);
}

// Accessibility remediation: Footer localization triggers rely on aria-label only, with no persistent visible label.
// Insert <label for="..."> before each popover trigger inside .footer__localization, reuse the theme-translated
// aria-label string, then remove aria-label to avoid duplication. WCAG 2.2 3.3.2 Labels or Instructions (A),
// 1.3.1 Info and Relationships (A).
function ensureFooterLocalizationVisibleLabel(relativeWrap) {
  if (!relativeWrap || !relativeWrap.closest('.footer__localization')) {
    return;
  }
  var btn = relativeWrap.querySelector('button[type="button"][aria-controls*="popover-localization-form"]');
  if (!btn) {
    return;
  }
  if (btn.dataset.a11yFooterLocalizationVisibleLabel === '1') {
    return;
  }

  var btnId = btn.id;
  if (btnId) {
    var labels = relativeWrap.querySelectorAll('label[for]');
    var already = Array.prototype.some.call(labels, function (lab) {
      return lab.getAttribute('for') === btnId && !lab.classList.contains('sr-only');
    });
    if (already) {
      btn.dataset.a11yFooterLocalizationVisibleLabel = '1';
      return;
    }
  } else {
    var baseId = 'a11y-footer-localization-trigger';
    var candidate = baseId;
    var n = 0;
    while (document.getElementById(candidate)) {
      n += 1;
      candidate = baseId + '-' + n;
    }
    btn.id = candidate;
    btnId = btn.id;
  }

  var labelText = (btn.getAttribute('aria-label') || '').trim();
  if (!labelText) {
    var ac = btn.getAttribute('aria-controls') || '';
    labelText =
      ac.indexOf('popover-localization-form-locale') !== -1
        ? 'Language'
        : ac.indexOf('popover-localization-form-country') !== -1
          ? 'Country and currency'
          : 'Region and currency';
  }

  var label = document.createElement('label');
  label.className = 'a11y-footer-localization-visible-label';
  label.setAttribute('for', btnId);
  label.textContent = labelText;

  relativeWrap.insertBefore(label, btn);
  btn.removeAttribute('aria-label');
  btn.dataset.a11yFooterLocalizationVisibleLabel = '1';
}

function initFooterLocalizationVisibleLabels(root) {
  var scope = root || document;
  scope.querySelectorAll('.footer__localization .relative').forEach(ensureFooterLocalizationVisibleLabel);
}

// Accessibility remediation: Mappy Store Locator (app-injected markup) ships `#bss-search-label` as `visually-hidden`
// with the text "Autocomplete" while the combobox uses `aria-labelledby` on that id. Move the same native `<label for>`
// above `.bss-wrapper-search-group`, strip the screen-reader-only class, and derive visible copy from the input
// placeholder (fallback "Your location") so sighted users get a persistent label without breaking the horizontal
// icon + field + search button row. WCAG 2.2 3.3.2 Labels or Instructions (A), 1.3.1 Info and Relationships (A).
function ensureMappyStoreLocatorLocationVisibleLabel() {
  var label = document.getElementById('bss-search-label');
  if (!label || label.nodeName !== 'LABEL') {
    return;
  }
  var input = document.getElementById('bss-search-input');
  if (!input) {
    return;
  }
  var header = document.getElementById('bss-wrapper-header');
  var searchGroup = header && header.querySelector('.bss-wrapper-search-group');
  if (!header || !searchGroup) {
    return;
  }
  if (label.dataset.a11yMappyLocationVisible === '1') {
    return;
  }

  var ph = (input.getAttribute('placeholder') || '').trim();
  var labelText = ph.replace(/^enter\s+/i, '').trim();
  if (!labelText) {
    labelText = 'Your location';
  } else if (labelText.length > 0 && labelText === labelText.toLowerCase()) {
    labelText = labelText.charAt(0).toUpperCase() + labelText.slice(1);
  }

  label.textContent = labelText;
  label.classList.remove('visually-hidden');
  label.classList.add('a11y-mappy-store-locator-location-label');
  header.classList.add('a11y-mappy-store-locator-header--stacked');
  header.insertBefore(label, searchGroup);
  label.dataset.a11yMappyLocationVisible = '1';
}

function initMappyStoreLocatorLocationVisibleLabels(root) {
  var scope = root || document;
  if (!scope.querySelector || !scope.querySelector('#bss-search-label')) {
    return;
  }
  ensureMappyStoreLocatorLocationVisibleLabel();
}

// Accessibility remediation: Judge.me app-injected review forms use visible copy ("Rating", "Picture/Video (optional)")
// with no programmatic name link to the hidden score field or the file input, which weakens 3.3.2. Legacy media: `label for`
// on the file input (labelable). Legacy rating: `input[type="hidden"]` is not labelable in HTML, so `label for` on the score
// field is invalid and is flagged as an orphaned/misassociated label; use `id` on the visible `<label>` and
// `aria-labelledby` on the hidden score input instead. Dynamic wizard: ids on `.jdgm-form__title` + `aria-labelledby` on
// inputs. Idempotent; re-runs on the existing subtree MutationObserver. WCAG 2.2 3.3.2 Labels or Instructions (A), 1.3.1 Info
// and Relationships (A).
function parallelleJudgeMeUniqueId(base) {
  var candidate = base;
  var n = 0;
  while (document.getElementById(candidate)) {
    n += 1;
    candidate = base + '-' + n;
  }
  return candidate;
}

function ensureJudgeMeLegacyRatingLabel(form) {
  if (!form || form.classList.contains('jdgm-form-dynamic')) {
    return;
  }
  var ratingSpan = form.querySelector('.jdgm-form__rating');
  if (!ratingSpan) {
    return;
  }
  var scoreInput = ratingSpan.querySelector('input[name="score"][type="hidden"]');
  if (!scoreInput) {
    return;
  }
  var fieldset = ratingSpan.closest('.jdgm-form__fieldset');
  if (!fieldset) {
    return;
  }
  var label = fieldset.querySelector(':scope > label');
  if (!label) {
    return;
  }
  if (!label.id) {
    label.id = parallelleJudgeMeUniqueId('a11y-jdgm-rating-label');
  }
  if (label.getAttribute('for')) {
    label.removeAttribute('for');
  }
  if (scoreInput.getAttribute('aria-labelledby') === label.id) {
    scoreInput.dataset.a11yJdgmRatingLabel = '1';
    return;
  }
  scoreInput.setAttribute('aria-labelledby', label.id);
  if (scoreInput.id && /^a11y-jdgm-score(-\d+)?$/.test(scoreInput.id)) {
    scoreInput.removeAttribute('id');
  }
  scoreInput.dataset.a11yJdgmRatingLabel = '1';
}

function ensureJudgeMeLegacyMediaLabel(form) {
  if (!form || form.classList.contains('jdgm-form-dynamic')) {
    return;
  }
  var fileInput = form.querySelector('.jdgm-media-fieldset__input[name="media"][type="file"]');
  if (!fileInput) {
    return;
  }
  var fieldset = fileInput.closest('.jdgm-form__fieldset');
  if (!fieldset) {
    return;
  }
  var label = fieldset.querySelector(':scope > label');
  if (!label) {
    return;
  }
  if (!fileInput.id) {
    fileInput.id = parallelleJudgeMeUniqueId('a11y-jdgm-review-media');
  }
  if (label.getAttribute('for') === fileInput.id) {
    fileInput.dataset.a11yJdgmMediaLabel = '1';
    return;
  }
  label.setAttribute('for', fileInput.id);
  if (fileInput.getAttribute('aria-label')) {
    fileInput.removeAttribute('aria-label');
  }
  fileInput.dataset.a11yJdgmMediaLabel = '1';
}

function ensureJudgeMeDynamicRowTitleRefs(form) {
  if (!form || !form.classList.contains('jdgm-form-dynamic')) {
    return;
  }
  var inners = form.querySelectorAll('.jdgm-form-dynamic__row-inner');
  var i;
  var inner;
  var title;
  var titleId;
  var fileInput;
  var scoreInput;
  var ratingSpan;
  for (i = 0; i < inners.length; i++) {
    inner = inners[i];
    title = inner.querySelector(':scope > .jdgm-form__title');
    if (!title || !title.textContent || !String(title.textContent).trim()) {
      continue;
    }
    if (!title.id) {
      title.id = parallelleJudgeMeUniqueId('a11y-jdgm-form-title');
    }
    titleId = title.id;

    fileInput = inner.querySelector('.jdgm-media-fieldset__input[name="media"][type="file"]');
    if (fileInput) {
      if (fileInput.getAttribute('aria-labelledby') === titleId) {
        fileInput.dataset.a11yJdgmDynamicMedia = '1';
      } else {
        fileInput.setAttribute('aria-labelledby', titleId);
        if (fileInput.getAttribute('aria-label')) {
          fileInput.removeAttribute('aria-label');
        }
        fileInput.dataset.a11yJdgmDynamicMedia = '1';
      }
    }

    ratingSpan = inner.querySelector('.jdgm-form-dynamic__rating');
    scoreInput = ratingSpan && ratingSpan.querySelector('input[name="score"][type="hidden"]');
    if (scoreInput) {
      if (scoreInput.getAttribute('aria-labelledby') === titleId) {
        scoreInput.dataset.a11yJdgmDynamicRating = '1';
      } else {
        scoreInput.setAttribute('aria-labelledby', titleId);
        scoreInput.dataset.a11yJdgmDynamicRating = '1';
      }
    }
  }
}

// Accessibility remediation: Judge.me renders rating “buttons” as `<a class="jdgm-star">` without `href`, so stars were
// skipped for sequential focus (`firstHref: null` in storefront probe). Adding `href="#"` when missing restores tab stops;
// capture-phase `click` prevents same-page hash jump; Enter/Space dispatch `click()` so keyboard matches mouse. Vendor JS
// also applies roving `tabindex="-1"` so only one star stays tabbable—after leaving the group, stars no longer receive Tab;
// we force `tabindex="0"` on every star on each sync and again on focusin/focusout (double rAF after focusin so we run after
// vendor). Capture `keydown` for Tab inside the same Judge.me `form` re-normalizes rating rows. **Tab** (forward) on a
// star `preventDefault`s and moves focus to the next focusable outside the rating `fieldset` / dynamic `row` so
// vendor cannot trap forward Tab until Enter selects a score; Shift+Tab from star index 1+ moves to the previous star
// when needed; from the first star, Shift+Tab is native (e.g. Cancel). Arrow keys remain for in-strip movement. Opening the form retries `focus()`
// on the first star (immediate, double rAF, +40…+1500 ms) so it wins over Judge.me focusing the review title. Write-review
// opened via Enter/Space sets `data-a11y-jdgm-write-rev-key` so we do not arm title refocus; any other open arms
// `data-a11y-jdgm-title-refocus-armed` and repeated `focusin` on `review_title` (bounded steal counter) return focus to the
// first star while the vendor keeps re-stealing it. When
// `aria-expanded` is not yet `true`, arm + stamp on the same capture `click` tick so synchronous vendor `focusin` on the
// title still sees the armed flag (deferred `setTimeout(0)` alone was too late). Shift+Tab from `review_title` when it is
// the immediate next focusable after the rightmost tab-ordered star focuses the star for `input[name="score"]` when set
// (else `.jdgm--on` count else that rightmost tab-ordered star). Mouse open also runs a short rAF loop while armed if
// focus remains on the title. Shift+Tab on star index greater than 0 focuses the previous star when the vendor blocks native
// backward movement. Scoped to `#judgeme_product_reviews` /
// `.jdgm-rev-widg`. WCAG 2.2 2.1.1 Keyboard (A), 2.4.3 Focus Order (A).
function parallelleJudgeMeFocusableSelectorString() {
  return (
    'a[href]:not([tabindex="-1"]),' +
    'button:not([disabled]):not([tabindex="-1"]),' +
    'input:not([disabled]):not([type="hidden"]):not([tabindex="-1"]),' +
    'select:not([disabled]):not([tabindex="-1"]),' +
    'textarea:not([disabled]):not([tabindex="-1"]),' +
    '[tabindex]:not([tabindex="-1"])'
  );
}

function parallelleJudgeMeIsFocusableCandidate(el) {
  if (!el || el.nodeType !== 1) {
    return false;
  }
  if (el.disabled) {
    return false;
  }
  if (el.getAttribute('aria-hidden') === 'true') {
    return false;
  }
  if (el.getAttribute('tabindex') === '-1') {
    return false;
  }
  var st = window.getComputedStyle(el);
  if (st.display === 'none' || st.visibility === 'hidden') {
    return false;
  }
  return true;
}

function parallelleJudgeMeQueryFocusablesInTreeOrder(root) {
  if (!root) {
    return [];
  }
  var raw = root.querySelectorAll(parallelleJudgeMeFocusableSelectorString());
  var out = [];
  var i;
  var el;
  for (i = 0; i < raw.length; i++) {
    el = raw[i];
    if (parallelleJudgeMeIsFocusableCandidate(el)) {
      out.push(el);
    }
  }
  return out;
}

function parallelleJudgeMeFirstFocusableIn(root) {
  var list = parallelleJudgeMeQueryFocusablesInTreeOrder(root);
  return list.length ? list[0] : null;
}

function parallelleJudgeMeRatingTabSection(star) {
  var dynRow = star.closest('.jdgm-form-dynamic__row');
  if (dynRow) {
    return dynRow;
  }
  return star.closest('.jdgm-form__fieldset');
}

function parallelleJudgeMeNextTabStopAfterSection(section) {
  if (!section) {
    return null;
  }
  var n = section.nextElementSibling;
  while (n) {
    var hit = parallelleJudgeMeFirstFocusableIn(n);
    if (hit) {
      return hit;
    }
    n = n.nextElementSibling;
  }
  return null;
}

// Accessibility remediation: Hidden `score` lives inside `.jdgm-form__rating`; `form.querySelector` can miss timing or
// ordering. Fall back to counting `.jdgm-star.jdgm--on` so Shift+Tab from the title targets the last lit star (WCAG 2.4.3).
function parallelleJudgeMeReadLegacyRatingScore(rowL, formLegacy) {
  var v = 0;
  var scoreEl = null;
  if (rowL && rowL.querySelector) {
    scoreEl = rowL.querySelector('input[name="score"]');
  }
  if (!scoreEl && formLegacy && formLegacy.querySelector) {
    scoreEl = formLegacy.querySelector('.jdgm-form__rating input[name="score"]');
  }
  if (scoreEl) {
    v = parseInt(String(scoreEl.value != null ? scoreEl.value : scoreEl.getAttribute('value') || '').trim(), 10);
    if (v !== v || v < 0) {
      v = 0;
    }
  }
  if (!v && rowL && rowL.querySelectorAll) {
    var lit = rowL.querySelectorAll('a.jdgm-star.jdgm--on').length;
    if (lit > 0) {
      v = lit;
    }
  }
  return v;
}

function parallelleJudgeMeAssertFirstStarWhileTitleFocused(widgetRoot, framesLeft) {
  if (!widgetRoot || framesLeft <= 0 || widgetRoot.isConnected === false) {
    return;
  }
  if (document.documentElement.getAttribute('data-a11y-jdgm-title-refocus-armed') !== '1') {
    return;
  }
  var titleEl = widgetRoot.querySelector('form.jdgm-form:not(.jdgm-form-dynamic) input[name="review_title"]');
  var firstStar = widgetRoot.querySelector('form.jdgm-form:not(.jdgm-form-dynamic) .jdgm-form__rating a.jdgm-star');
  if (titleEl && firstStar && document.activeElement === titleEl) {
    try {
      firstStar.focus({ preventScroll: true });
    } catch (af) {
      /* ignore */
    }
    var rowA = firstStar.closest('.jdgm-form__rating');
    if (rowA) {
      parallelleJudgeMeNormalizeStarTabStops(rowA);
    }
  }
  window.requestAnimationFrame(function () {
    parallelleJudgeMeAssertFirstStarWhileTitleFocused(widgetRoot, framesLeft - 1);
  });
}

function parallelleJudgeMeFocusFirstStarAfterOpen(widgetRoot) {
  if (!widgetRoot) {
    return;
  }
  var first =
    widgetRoot.querySelector('form.jdgm-form:not(.jdgm-form-dynamic) .jdgm-form__rating a.jdgm-star') ||
    widgetRoot.querySelector('.jdgm-form-dynamic__rating a.jdgm-star');
  if (!first) {
    return;
  }
  function tryFocus() {
    try {
      first.focus({ preventScroll: true });
    } catch (err) {
      /* ignore */
    }
    var r = first.closest('.jdgm-form__rating, .jdgm-form-dynamic__rating');
    if (r) {
      parallelleJudgeMeNormalizeStarTabStops(r);
    }
  }
  tryFocus();
  window.requestAnimationFrame(function () {
    window.requestAnimationFrame(function () {
      tryFocus();
      window.setTimeout(function () {
        tryFocus();
        window.setTimeout(function () {
          tryFocus();
        }, 80);
        window.setTimeout(function () {
          tryFocus();
        }, 200);
        window.setTimeout(function () {
          tryFocus();
        }, 400);
        window.setTimeout(function () {
          tryFocus();
        }, 650);
        window.setTimeout(function () {
          tryFocus();
        }, 1000);
        window.setTimeout(function () {
          tryFocus();
        }, 1500);
      }, 40);
    });
  });
}

function parallelleJudgeMeNormalizeStarTabStops(ratingRow) {
  if (!ratingRow) {
    return;
  }
  var stars = ratingRow.querySelectorAll('a.jdgm-star');
  var j;
  var node;
  for (j = 0; j < stars.length; j++) {
    node = stars[j];
    node.setAttribute('tabindex', '0');
  }
}

function ensureJudgeMeRatingStarsKeyboardAttributes(widgetRoot) {
  if (!widgetRoot) {
    return;
  }
  var rows = widgetRoot.querySelectorAll('.jdgm-form__rating, .jdgm-form-dynamic__rating');
  var i;
  var row;
  var stars;
  var k;
  var a;
  var href;
  for (i = 0; i < rows.length; i++) {
    row = rows[i];
    parallelleJudgeMeNormalizeStarTabStops(row);
    stars = row.querySelectorAll('a.jdgm-star');
    for (k = 0; k < stars.length; k++) {
      a = stars[k];
      href = (a.getAttribute('href') || '').trim();
      if (!href) {
        a.setAttribute('href', '#');
      }
    }
  }
}

function ensureJudgeMeRatingStarKeyboardDelegation() {
  if (typeof document === 'undefined' || document.documentElement.dataset.a11yJdgmStarKbDoc === '1') {
    return;
  }
  document.documentElement.dataset.a11yJdgmStarKbDoc = '1';
  var jdgmTitleArmClearTimer = null;
  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) {
        return;
      }
      var star = t.closest('.jdgm-form__rating a.jdgm-star, .jdgm-form-dynamic__rating a.jdgm-star');
      if (star && star.closest('#judgeme_product_reviews, .jdgm-rev-widg')) {
        var h = (star.getAttribute('href') || '').trim();
        if (h === '#' || h === '') {
          e.preventDefault();
        }
        return;
      }
      var link = t.closest('.jdgm-write-rev-link');
      if (!link || !link.closest('#judgeme_product_reviews, .jdgm-rev-widg')) {
        return;
      }
      // Accessibility remediation: Judge.me can focus `review_title` in the same turn as the opening click, before a
      // deferred `setTimeout(0)` runs—so arm + stamp synchronously when this click is opening (not already expanded).
      var expBefore = (link.getAttribute('aria-expanded') || '').trim();
      var wSync = link.closest('#judgeme_product_reviews, .jdgm-rev-widg');
      if (wSync && expBefore !== 'true') {
        var openedByKbSync = document.documentElement.getAttribute('data-a11y-jdgm-write-rev-key') === '1';
        if (!openedByKbSync) {
          document.documentElement.setAttribute('data-a11y-jdgm-title-refocus-armed', '1');
          wSync.dataset.a11yJdgmOpenStamp = String(Date.now());
          delete wSync.dataset.a11yJdgmTitleStealCount;
          window.clearTimeout(jdgmTitleArmClearTimer);
          jdgmTitleArmClearTimer = window.setTimeout(function () {
            document.documentElement.removeAttribute('data-a11y-jdgm-title-refocus-armed');
          }, 2600);
        }
      }
      window.setTimeout(function () {
        var exp = link.getAttribute('aria-expanded') || '';
        var w = link.closest('#judgeme_product_reviews, .jdgm-rev-widg');
        if (exp !== 'true') {
          if (w) {
            delete w.dataset.a11yJdgmOpenStamp;
            delete w.dataset.a11yJdgmTitleStealCount;
          }
          document.documentElement.removeAttribute('data-a11y-jdgm-title-refocus-armed');
          window.clearTimeout(jdgmTitleArmClearTimer);
          return;
        }
        if (!w) {
          return;
        }
        var openedByKeyboard = document.documentElement.getAttribute('data-a11y-jdgm-write-rev-key') === '1';
        if (!openedByKeyboard) {
          document.documentElement.setAttribute('data-a11y-jdgm-title-refocus-armed', '1');
        } else {
          document.documentElement.removeAttribute('data-a11y-jdgm-title-refocus-armed');
        }
        w.dataset.a11yJdgmOpenStamp = String(Date.now());
        delete w.dataset.a11yJdgmTitleStealCount;
        window.clearTimeout(jdgmTitleArmClearTimer);
        jdgmTitleArmClearTimer = window.setTimeout(function () {
          document.documentElement.removeAttribute('data-a11y-jdgm-title-refocus-armed');
        }, 2600);
        parallelleJudgeMeFocusFirstStarAfterOpen(w);
        if (!openedByKeyboard) {
          parallelleJudgeMeAssertFirstStarWhileTitleFocused(w, 96);
        }
      }, 0);
    },
    true
  );
  document.addEventListener(
    'keydown',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) {
        return;
      }
      if ((e.key === 'Enter' || e.key === ' ') && t.closest) {
        var wrAct = t.closest('.jdgm-write-rev-link');
        if (wrAct && wrAct.closest('#judgeme_product_reviews, .jdgm-rev-widg')) {
          document.documentElement.setAttribute('data-a11y-jdgm-write-rev-key', '1');
          window.setTimeout(function () {
            document.documentElement.removeAttribute('data-a11y-jdgm-write-rev-key');
          }, 900);
        }
      }
      if (e.key === 'Tab') {
        var formLegacy = t.closest('form.jdgm-form:not(.jdgm-form-dynamic)');
        if (formLegacy && formLegacy.closest('#judgeme_product_reviews, .jdgm-rev-widg')) {
          var rowL = formLegacy.querySelector('.jdgm-form__rating');
          if (rowL) {
            parallelleJudgeMeNormalizeStarTabStops(rowL);
          }
          if (e.shiftKey && rowL && t.matches && t.matches('input[name="review_title"]')) {
            var ord = parallelleJudgeMeQueryFocusablesInTreeOrder(formLegacy);
            var sl2 = rowL.querySelectorAll('a.jdgm-star');
            var maxTabIdx = -1;
            var maxTabStar = null;
            var sx;
            for (sx = 0; sx < sl2.length; sx++) {
              var ix = ord.indexOf(sl2[sx]);
              if (ix > maxTabIdx) {
                maxTabIdx = ix;
                maxTabStar = sl2[sx];
              }
            }
            var titleIdx = ord.indexOf(t);
            var FOLLOWING = typeof Node !== 'undefined' ? Node.DOCUMENT_POSITION_FOLLOWING : 4;
            var posOk = !!(rowL.compareDocumentPosition(t) & FOLLOWING);
            var fsOk = false;
            var ratingFs = rowL.closest('.jdgm-form__fieldset');
            var tFs = t.closest('.jdgm-form__fieldset');
            if (ratingFs && tFs && formLegacy.contains(ratingFs) && formLegacy.contains(tFs)) {
              var allFs = formLegacy.querySelectorAll('.jdgm-form__fieldset');
              var arr = [];
              var ai;
              for (ai = 0; ai < allFs.length; ai++) {
                if (formLegacy.contains(allFs[ai])) {
                  arr.push(allFs[ai]);
                }
              }
              var rIdx = arr.indexOf(ratingFs);
              var tIdx = arr.indexOf(tFs);
              fsOk = rIdx !== -1 && tIdx === rIdx + 1;
            }
            var tabOrderOkBool = maxTabIdx !== -1 && titleIdx === maxTabIdx + 1 && maxTabStar !== null;
            var scoreVal = parallelleJudgeMeReadLegacyRatingScore(rowL, formLegacy);
            var shiftStarTarget = null;
            if (scoreVal >= 1 && scoreVal <= sl2.length) {
              shiftStarTarget = sl2[scoreVal - 1];
            }
            if (!shiftStarTarget) {
              shiftStarTarget = maxTabStar;
            }
            if (shiftStarTarget && (tabOrderOkBool || (posOk && fsOk))) {
              e.preventDefault();
              e.stopImmediatePropagation();
              try {
                shiftStarTarget.focus();
              } catch (x) {
                /* ignore */
              }
              window.requestAnimationFrame(function () {
                window.requestAnimationFrame(function () {
                  parallelleJudgeMeNormalizeStarTabStops(rowL);
                });
              });
              return;
            }
          }
        }
        var formDyn = t.closest('form.jdgm-form.jdgm-form-dynamic');
        if (formDyn && formDyn.closest('#judgeme_product_reviews, .jdgm-rev-widg')) {
          formDyn.querySelectorAll('.jdgm-form-dynamic__rating').forEach(parallelleJudgeMeNormalizeStarTabStops);
        }
        var starTab = t.closest('.jdgm-form__rating a.jdgm-star, .jdgm-form-dynamic__rating a.jdgm-star');
        if (starTab && starTab.closest('#judgeme_product_reviews, .jdgm-rev-widg')) {
          var rowTab = starTab.closest('.jdgm-form__rating, .jdgm-form-dynamic__rating');
          if (rowTab) {
            parallelleJudgeMeNormalizeStarTabStops(rowTab);
          }
          var starList = rowTab ? rowTab.querySelectorAll('a.jdgm-star') : [];
          var starIdx = Array.prototype.indexOf.call(starList, starTab);
          // Accessibility remediation: Judge.me / Raty often block native Shift+Tab between stars; move focus to the
          // previous star explicitly (index 0 falls through so Shift+Tab can reach Cancel / controls above the strip).
          if (e.shiftKey && starIdx > 0) {
            e.preventDefault();
            e.stopImmediatePropagation();
            try {
              starList[starIdx - 1].focus();
            } catch (sf) {
              /* ignore */
            }
            window.requestAnimationFrame(function () {
              window.requestAnimationFrame(function () {
                if (rowTab) {
                  parallelleJudgeMeNormalizeStarTabStops(rowTab);
                }
              });
            });
            return;
          }
          var sec = parallelleJudgeMeRatingTabSection(starTab);
          if (sec) {
            // Accessibility remediation: Only forward Tab jumps out of the strip; Shift+Tab from star 1 is native.
            var destination = e.shiftKey ? null : parallelleJudgeMeNextTabStopAfterSection(sec);
            if (destination) {
              e.preventDefault();
              e.stopImmediatePropagation();
              try {
                destination.focus();
              } catch (fe) {
                /* ignore */
              }
            }
          }
        }
        return;
      }
      if (e.key !== 'Enter' && e.key !== ' ') {
        return;
      }
      var star = t.closest('.jdgm-form__rating a.jdgm-star, .jdgm-form-dynamic__rating a.jdgm-star');
      if (!star || !star.closest('#judgeme_product_reviews, .jdgm-rev-widg')) {
        return;
      }
      e.preventDefault();
      star.click();
    },
    true
  );
  document.addEventListener(
    'focusin',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) {
        return;
      }
      var widge = t.closest('#judgeme_product_reviews, .jdgm-rev-widg');
      if (
        widge &&
        t.matches &&
        t.matches('input[name="review_title"]') &&
        document.documentElement.getAttribute('data-a11y-jdgm-title-refocus-armed') === '1'
      ) {
        var stamp = parseInt(widge.dataset.a11yJdgmOpenStamp || '0', 10);
        var stealN = parseInt(widge.dataset.a11yJdgmTitleStealCount || '0', 10) || 0;
        var stealMax = 32;
        var stampWindowMs = 2500;
        if (stamp && Date.now() - stamp < stampWindowMs && stealN < stealMax) {
          var firstStar = widge.querySelector(
            'form.jdgm-form:not(.jdgm-form-dynamic) .jdgm-form__rating a.jdgm-star'
          );
          if (firstStar && t !== firstStar) {
            widge.dataset.a11yJdgmTitleStealCount = String(stealN + 1);
            try {
              firstStar.focus({ preventScroll: true });
            } catch (re) {
              /* ignore */
            }
            var row0 = firstStar.closest('.jdgm-form__rating');
            if (row0) {
              parallelleJudgeMeNormalizeStarTabStops(row0);
            }
            return;
          }
        }
      }
      var row = t.closest('.jdgm-form__rating, .jdgm-form-dynamic__rating');
      if (!row || !row.closest('#judgeme_product_reviews, .jdgm-rev-widg')) {
        return;
      }
      parallelleJudgeMeNormalizeStarTabStops(row);
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          parallelleJudgeMeNormalizeStarTabStops(row);
        });
      });
    },
    true
  );
  document.addEventListener(
    'focusout',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) {
        return;
      }
      var row = t.closest('.jdgm-form__rating, .jdgm-form-dynamic__rating');
      if (!row || !row.closest('#judgeme_product_reviews, .jdgm-rev-widg')) {
        return;
      }
      var rt = e.relatedTarget;
      if (rt && row.contains(rt)) {
        return;
      }
      window.requestAnimationFrame(function () {
        parallelleJudgeMeNormalizeStarTabStops(row);
      });
    },
    true
  );
}

function initJudgeMeReviewFormLabels(root) {
  var scope = root || document;
  var roots = scope.querySelectorAll('#judgeme_product_reviews');
  if (!roots.length) {
    roots = scope.querySelectorAll('.jdgm-rev-widg');
  }
  if (!roots.length) {
    return;
  }
  var ri;
  var widget;
  for (ri = 0; ri < roots.length; ri++) {
    widget = roots[ri];
    widget.querySelectorAll('form.jdgm-form:not(.jdgm-form-dynamic)').forEach(function (f) {
      ensureJudgeMeLegacyRatingLabel(f);
      ensureJudgeMeLegacyMediaLabel(f);
    });
    widget.querySelectorAll('form.jdgm-form.jdgm-form-dynamic').forEach(ensureJudgeMeDynamicRowTitleRefs);
    ensureJudgeMeRatingStarsKeyboardAttributes(widget);
  }
}

// Accessibility remediation: Some JSON templates disable `collection-banner` or omit `main-page`, so `#main` can ship
// with no `h1` while the homepage already uses `<h1 class="header__logo">` inside `store-header` (outside `#main`).
// When `#main` has no native `h1`, prepend one sr-only heading using the Liquid-provided `data-a11y-page-h1-fallback-text`
// (same source as `<title>`, typically the collection/page name). Idempotent via `data-a11y-page-h1-fallback` on the
// injected node; re-query avoids duplicate h1 if sections hydrate later. WCAG 2.2 1.3.1 Info and Relationships (A),
// 2.4.6 Headings and Labels (AA).
function ensurePageH1Fallback() {
  if (typeof document === 'undefined') {
    return;
  }
  var main = document.getElementById('main');
  if (!main) {
    return;
  }
  if (main.querySelector('[data-a11y-page-h1-fallback="1"]')) {
    return;
  }
  if (main.querySelector('h1:not([data-a11y-page-h1-fallback="1"])')) {
    return;
  }
  if (document.querySelector('store-header h1')) {
    return;
  }
  var body = document.body;
  var title = (body && body.dataset && body.dataset.a11yPageH1FallbackText ? body.dataset.a11yPageH1FallbackText : '')
    .replace(/\s+/g, ' ')
    .trim();
  if (!title) {
    return;
  }
  var h1 = document.createElement('h1');
  h1.className = 'sr-only';
  h1.setAttribute('data-a11y-page-h1-fallback', '1');
  h1.textContent = title;
  main.insertBefore(h1, main.firstChild);
}

// Accessibility remediation: Rich text, FAQ, and accordion-content sections output editor HTML where <a> may
// include title="..." (duplicate or divergent from visible link text). Removing title keeps the accessible name from
// link text alone (WCAG 2.4.4 Link Purpose (In Context) (A), 4.1.2 Name, Role, Value (A)). Scoped to
// [data-a11y-strip-link-titles] on those section roots (sections/rich-text.liquid, sections/faq.liquid,
// sections/accordion-content.liquid).
function stripScopedSectionLinkTitles() {
  if (typeof document === 'undefined') {
    return;
  }
  document.querySelectorAll('[data-a11y-strip-link-titles] a[title]').forEach(function (anchor) {
    anchor.removeAttribute('title');
  });
}

// Accessibility remediation: Shopify’s storefront hCaptcha badge (`#shop-hcaptcha-badge-container`) injects a logo
// `<img alt="Protected by hCaptcha">` next to the same string in `.info span`, so assistive tech announces it twice.
// When the trimmed alt matches the adjacent visible text, treat the image as decorative with `alt=""` (WCAG 2.2
// 1.1.1 Non-text Content (A)). Idempotent via `data-a11y-hcaptcha-logo-deduped` on the img; re-runs if the node is replaced.
function fixShopHcaptchaBadgeRedundantLogoAlt() {
  if (typeof document === 'undefined') {
    return;
  }
  var badge = document.getElementById('shop-hcaptcha-badge-container');
  if (!badge) {
    return;
  }
  var img = badge.querySelector('img');
  if (!img || img.getAttribute('data-a11y-hcaptcha-logo-deduped') === '1') {
    return;
  }
  var span = badge.querySelector('.info span');
  var alt = (img.getAttribute('alt') || '').replace(/\s+/g, ' ').trim();
  var text = span ? (span.textContent || '').replace(/\s+/g, ' ').trim() : '';
  if (!text || alt.toLowerCase() !== text.toLowerCase()) {
    return;
  }
  img.setAttribute('alt', '');
  img.setAttribute('data-a11y-hcaptcha-logo-deduped', '1');
}

// Accessibility remediation: AI-generated image carousel blocks output product-media `alt` on slide images while each
// slide also has visible caption copy (`.ai-image-carousel-slide-text-*` / `.ai-image-carousel__slide-content-*`),
// so assistive technology reads long redundant descriptions. When a slide has non-empty visible caption text, treat the
// image as decorative with `alt=""` (WCAG 2.2 1.1.1 Non-text Content (A)). Idempotent via `data-a11y-carousel-decorative`.
function fixImageCarouselSlidesWithVisibleCaptions() {
  if (typeof document === 'undefined') {
    return;
  }
  // Prior run matched `ai-image-carousel-slide-image-wrapper-*` before the `<img>`; strip invalid attrs from wrappers.
  document
    .querySelectorAll('[class*="ai-image-carousel-slide-image-wrapper-"][data-a11y-carousel-decorative]')
    .forEach(function (wrapper) {
      wrapper.removeAttribute('alt');
      wrapper.removeAttribute('data-a11y-carousel-decorative');
    });
  var slideSelector =
    '[class*="ai-image-carousel-slide-"][data-slide], [class*="ai-image-carousel__slide-"][data-slide]';
  document.querySelectorAll(slideSelector).forEach(function (slide) {
    var caption = slide.querySelector(
      '[class*="ai-image-carousel-slide-text-"], [class*="ai-image-carousel__slide-content-"]'
    );
    if (!caption || !(caption.textContent || '').replace(/\s+/g, ' ').trim()) {
      return;
    }
    var img = slide.querySelector(
      'img[class*="ai-image-carousel-slide-image-"], img[class*="ai-image-carousel__slide-image-"]'
    );
    if (!img || img.getAttribute('data-a11y-carousel-decorative') === '1') {
      return;
    }
    img.setAttribute('alt', '');
    img.setAttribute('data-a11y-carousel-decorative', '1');
  });
}

// Accessibility remediation: The storefront hCaptcha widget adds `textarea[name="h-captcha-response"]` for the token;
// it is not meant for users. Inline `display:none` alone can lose to author styles; it may also remain in the tab
// order in edge cases. Exclude it from sequential focus (WCAG 2.2 2.4.3 Focus Order (A)). The field has no `<label>`,
// so tools like WAVE flag a missing name; `aria-label` supplies a programmatic name without implying user input
// (WCAG 2.2 4.1.2 Name, Role, Value (A)). `tabindex`/`data-a11y-hcaptcha-response-field` once per node; `aria-label`
// is (re)applied whenever it is empty so prior runs can pick up the label without replacing a vendor-set name.
function fixHcaptchaResponseTextareaHidden() {
  if (typeof document === 'undefined') {
    return;
  }
  document.querySelectorAll('textarea[name="h-captcha-response"]').forEach(function (el) {
    if (el.getAttribute('data-a11y-hcaptcha-response-field') !== '1') {
      el.setAttribute('data-a11y-hcaptcha-response-field', '1');
      el.setAttribute('tabindex', '-1');
    }
    if (!(el.getAttribute('aria-label') || '').trim()) {
      el.setAttribute('aria-label', 'hCaptcha verification response');
    }
  });
}

// Accessibility remediation: Judge.me review display ratings (`span.jdgm-rev__rating[role="img"]`) ship with
// `tabindex="0"` making them keyboard-focusable despite having no interactive functionality. Remove `tabindex`
// so the non-interactive `role="img"` elements no longer appear in the sequential focus order.
// Same treatment for the current-page pagination indicator (`.jdgm-paginate__page.jdgm-curt`): it represents the
// already-active page with no navigation action, so it should not be a tab stop; `aria-current="page"` is added
// for correct semantics. WCAG 2.2 2.4.3 Focus Order (A).
function fixJudgeMeNonInteractiveTabindex() {
  var ratings = document.querySelectorAll('.jdgm-rev__rating[tabindex="0"]');
  for (var i = 0; i < ratings.length; i++) {
    var el = ratings[i];
    if (el.closest('form')) {
      continue;
    }
    el.removeAttribute('tabindex');
  }

  var curPages = document.querySelectorAll('.jdgm-paginate__page.jdgm-curt[tabindex="0"]');
  for (var j = 0; j < curPages.length; j++) {
    curPages[j].removeAttribute('tabindex');
    curPages[j].setAttribute('aria-current', 'page');
  }
}

// Accessibility remediation: Route’s cart protection accordion uses a non-standard
// `role="expand-benefits-button"` header (not announced as expanded/collapsed by screen readers) and
// toggles `#protection-benefits` with `aria-hidden` and open/closed classes. Remap the header to
// `role="button"` with `aria-expanded` / `aria-controls`, one tab stop (info icon `tabindex="-1"` +
// `aria-hidden="true"`), and `inert` on the collapsed panel. WCAG 2.2 4.1.2 Name, Role, Value (A);
// 2.4.3 Focus Order (A); 2.1.1 Keyboard (A).
function routeProtectionBenefitsPanelIsClosed(panel) {
  return (
    panel.classList.contains('pw-benefits-table--closed') || panel.getAttribute('aria-hidden') === 'true'
  );
}

function routeProtectionAccordionHeaderForPanel(panel) {
  if (!panel) {
    return null;
  }
  // Route places the header inside `.pw-accordion-benefits-container` but `#protection-benefits`
  // is a sibling of that wrapper, not a descendant — `panel.closest('.pw-accordion-benefits-container')`
  // is always null and ARIA never synced without scoping from the widget/checkout root.
  var scope =
    panel.closest('[data-protection-widget="true"]') ||
    panel.closest('.pw-variant-preferred-checkout') ||
    panel.parentElement;
  if (!scope) {
    return null;
  }
  return (
    scope.querySelector(routeProtectionAccordionTriggerSelector()) ||
    scope.querySelector(
      '.pw-cashback-header-container[role="expand-benefits-button"], [role="expand-benefits-button"]'
    )
  );
}

function routeProtectionAccordionUniqueId(base) {
  var candidate = base;
  var n = 0;
  while (document.getElementById(candidate)) {
    n += 1;
    candidate = base + '-' + n;
  }
  return candidate;
}

function routeProtectionAccordionHeaderAccessibleName(header) {
  if (!header) {
    return '';
  }
  var parts = [];
  var desc = header.querySelector('#pw-coverage-description, .pw-coverage-description');
  if (desc) {
    var dt = (desc.textContent || '').replace(/\s+/g, ' ').trim();
    if (dt) {
      parts.push(dt);
    }
  }
  var hint = header.querySelector('.pw-cashback-tooltip-text');
  if (hint) {
    var ht = (hint.textContent || '').replace(/\s+/g, ' ').trim();
    if (ht) {
      parts.push(ht);
    }
  }
  return parts.join('. ');
}

function routeProtectionAccordionTriggerSelector() {
  return '.pw-cashback-header-container[data-a11y-route-accordion-trigger]';
}

// Accessibility remediation: Route’s info icon and header row both toggled the accordion, creating two tab
// stops for one action. Keep the icon clickable for mouse users but remove it from the tab order and AT tree
// so the header is the single disclosure control (WCAG 2.2 2.4.3 Focus Order (A)).
// Accessibility remediation: MOB-037 - a native <button> nested inside the role="button" header fails
// axe nested-interactive no matter what ARIA is stamped on it: tabindex=-1 + aria-hidden do not satisfy
// the rule (live-verified 2026-07-06), and role="presentation" is IGNORED on natively focusable elements
// per ARIA conflict resolution (live-verified 2026-07-07, causal test: removing the node dropped the
// violation to zero). The only real fix is removing the native button from inside the interactive header:
// swap it to a decorative <span> (same classes/attributes, children moved). Mouse clicks on the span still
// bubble to the accordion's document-level click delegation, so the icon area keeps toggling the accordion;
// the header remains the single disclosure control (WCAG 2.2 4.1.2 Name, Role, Value (A)).
function syncRouteProtectionAccordionInfoButtonFocus(header) {
  if (!header) {
    return;
  }
  var infoBtn = header.querySelector(
    '.pw-info-icon, button.pw-info-icon, [data-trademark-learn-more="true"]'
  );
  if (!infoBtn) {
    return;
  }
  if (infoBtn.tagName === 'BUTTON') {
    var span = document.createElement('span');
    for (var ai = 0; ai < infoBtn.attributes.length; ai++) {
      var attr = infoBtn.attributes[ai];
      if (attr.name === 'type' || attr.name === 'tabindex' || attr.name === 'role' || attr.name === 'disabled' || attr.name === 'aria-haspopup' || attr.name === 'aria-expanded') {
        continue;
      }
      span.setAttribute(attr.name, attr.value);
    }
    span.setAttribute('data-a11y-route-info-swapped', 'true');
    while (infoBtn.firstChild) {
      span.appendChild(infoBtn.firstChild);
    }
    if (infoBtn.parentNode) {
      infoBtn.parentNode.replaceChild(span, infoBtn);
    }
    infoBtn = span;
  }
  if (infoBtn.getAttribute('aria-hidden') !== 'true') {
    infoBtn.setAttribute('aria-hidden', 'true');
  }
  if (infoBtn.hasAttribute('tabindex')) {
    infoBtn.removeAttribute('tabindex');
  }
  if (infoBtn.hasAttribute('role')) {
    infoBtn.removeAttribute('role');
  }
}

// Accessibility remediation: MOB-036 - Route renders each benefit row title as
// `<span class="pw-cashback-benefits-title" role="benefits-title">`; `benefits-title` is not a valid ARIA
// role, so AT expose an unknown/invalid role for the span (axe: aria-roles). The visible text already conveys
// the title and no landmark/heading semantics are known-correct here, so the sanctioned fix is to strip the
// invalid role, leaving a plain text span. Idempotent, and runs in the accordion sync path so it re-applies on
// every Route re-render (WCAG 2.2 4.1.2 Name, Role, Value (A)).
function syncRouteProtectionBenefitsTitleRoles(panel) {
  if (!panel) {
    return;
  }
  var titles = panel.querySelectorAll('.pw-cashback-benefits-title[role="benefits-title"]');
  for (var i = 0; i < titles.length; i++) {
    titles[i].removeAttribute('role');
  }
}

// Accessibility remediation: MOB-037 - the header row `.pw-cashback-header-container[role="button"][tabindex="0"]`
// contains a nested `<button>` ("See what's included"). A button inside a button is a nested-interactive control
// (axe: nested-interactive, serious) and adds a redundant second control for the same disclosure. The theme
// already sets that inner button `tabindex="-1"`, and its label is already carried in the header's
// `aria-labelledby` (a11y-route-coverage-hint), so it is fully redundant to AT. Hide it from the a11y tree with
// `aria-hidden="true"` (and re-assert `tabindex="-1"` defensively) so the header exposes a single button. This is
// scoped to the "See what's included" trigger and deliberately does NOT touch the info icon, which
// `syncRouteProtectionAccordionInfoButtonFocus` owns. Runs in the sync path, idempotent, observer-safe
// (WCAG 2.2 4.1.2 Name, Role, Value (A); 2.4.3 Focus Order (A)).
function syncRouteProtectionAccordionSeeIncludedButton(header) {
  if (!header) {
    return;
  }
  var buttons = header.querySelectorAll('button.pw-cashback-see-details, button.pw-cashback-see-included');
  if (!buttons.length) {
    // Fall back to any nested <button> that is NOT the info icon owned by the info-button sync path.
    var all = header.querySelectorAll('button');
    for (var b = 0; b < all.length; b++) {
      var btn = all[b];
      if (
        btn.classList.contains('pw-info-icon') ||
        btn.getAttribute('data-trademark-learn-more') === 'true'
      ) {
        continue;
      }
      if (btn.getAttribute('aria-hidden') !== 'true') {
        btn.setAttribute('aria-hidden', 'true');
      }
      if (btn.getAttribute('tabindex') !== '-1') {
        btn.setAttribute('tabindex', '-1');
      }
    }
    return;
  }
  for (var i = 0; i < buttons.length; i++) {
    if (buttons[i].getAttribute('aria-hidden') !== 'true') {
      buttons[i].setAttribute('aria-hidden', 'true');
    }
    if (buttons[i].getAttribute('tabindex') !== '-1') {
      buttons[i].setAttribute('tabindex', '-1');
    }
  }
}

function syncRouteProtectionAccordionAria(panel) {
  var header = routeProtectionAccordionHeaderForPanel(panel);
  if (!header || !panel) {
    return;
  }
  syncRouteProtectionBenefitsTitleRoles(panel);
  header.setAttribute('data-a11y-route-accordion-trigger', 'true');
  if (header.getAttribute('role') !== 'button') {
    header.setAttribute('role', 'button');
  }
  var closed = routeProtectionBenefitsPanelIsClosed(panel);
  var expanded = closed ? 'false' : 'true';
  if (header.getAttribute('aria-expanded') !== expanded) {
    header.setAttribute('aria-expanded', expanded);
  }
  if (panel.id && header.getAttribute('aria-controls') !== panel.id) {
    header.setAttribute('aria-controls', panel.id);
  }
  if (header.getAttribute('tabindex') !== '0') {
    header.setAttribute('tabindex', '0');
  }
  syncRouteProtectionAccordionInfoButtonFocus(header);
  syncRouteProtectionAccordionSeeIncludedButton(header);

  var desc = header.querySelector('#pw-coverage-description, .pw-coverage-description');
  var hint = header.querySelector('.pw-cashback-tooltip-text');
  if (desc) {
    if (!desc.id) {
      desc.id = routeProtectionAccordionUniqueId('a11y-route-coverage-description');
    }
    if (hint) {
      if (!hint.id) {
        hint.id = routeProtectionAccordionUniqueId('a11y-route-coverage-hint');
      }
      var labelledBy = desc.id + ' ' + hint.id;
      if (header.getAttribute('aria-labelledby') !== labelledBy) {
        header.setAttribute('aria-labelledby', labelledBy);
      }
      if (header.hasAttribute('aria-label')) {
        header.removeAttribute('aria-label');
      }
    } else {
      if (header.getAttribute('aria-labelledby') !== desc.id) {
        header.setAttribute('aria-labelledby', desc.id);
      }
      if (header.hasAttribute('aria-label')) {
        header.removeAttribute('aria-label');
      }
    }
  } else {
    var built = routeProtectionAccordionHeaderAccessibleName(header);
    if (built && header.getAttribute('aria-label') !== built) {
      header.setAttribute('aria-label', built);
    }
  }
}

function bindRouteProtectionAccordionHeaderObserver(header, panel) {
  if (!header || !panel || header.dataset.a11yRouteHeaderObs === '1') {
    return;
  }
  header.dataset.a11yRouteHeaderObs = '1';
  new MutationObserver(function () {
    syncRouteProtectionAccordionAria(panel);
  }).observe(header, {
    attributes: true,
    attributeFilter: [
      'aria-expanded',
      'aria-controls',
      'aria-labelledby',
      'aria-label',
      'tabindex',
      'role'
    ]
  });
}

function syncRouteProtectionAccordionInert(panel) {
  if (!panel) {
    return;
  }
  var closed = routeProtectionBenefitsPanelIsClosed(panel);
  if (closed) {
    if (!panel.hasAttribute('inert')) {
      panel.setAttribute('inert', '');
    }
    var active = document.activeElement;
    if (active && panel.contains(active)) {
      var header = routeProtectionAccordionHeaderForPanel(panel);
      var focusTarget = header;
      if (focusTarget && typeof focusTarget.focus === 'function') {
        try {
          focusTarget.focus({ preventScroll: true });
        } catch (err) {
          /* ignore */
        }
      }
    }
  } else {
    panel.removeAttribute('inert');
  }
}

function syncRouteProtectionAccordion(panel) {
  var header = routeProtectionAccordionHeaderForPanel(panel);
  if (header) {
    bindRouteProtectionAccordionHeaderObserver(header, panel);
  }
  syncRouteProtectionAccordionAria(panel);
  syncRouteProtectionAccordionInert(panel);
}

function bindRouteProtectionBenefitsPanelObserver(panel) {
  if (!panel || panel.dataset.a11yRouteBenefitsObs === '1') {
    return;
  }
  panel.dataset.a11yRouteBenefitsObs = '1';
  new MutationObserver(function () {
    syncRouteProtectionAccordion(panel);
  }).observe(panel, { attributes: true, attributeFilter: ['class', 'aria-hidden'] });
}

function fixRouteProtectionAccordion() {
  if (typeof document === 'undefined') {
    return;
  }
  var panels = document.querySelectorAll(
    '#protection-benefits.pw-benefits-table, .pw-benefits-table[data-selector="preferred-checkout-benefits-table"]'
  );
  var i;
  for (i = 0; i < panels.length; i++) {
    bindRouteProtectionBenefitsPanelObserver(panels[i]);
    syncRouteProtectionAccordion(panels[i]);
  }
}

function ensureRouteProtectionAccordionToggleSync() {
  if (typeof document === 'undefined' || document.documentElement.dataset.a11yRouteAccordionClick === '1') {
    return;
  }
  document.documentElement.dataset.a11yRouteAccordionClick = '1';
  document.addEventListener(
    'click',
    function (e) {
      var header =
        e.target &&
        e.target.closest &&
        e.target.closest(routeProtectionAccordionTriggerSelector());
      if (!header || !header.closest('[data-protection-widget="true"]')) {
        return;
      }
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(fixRouteProtectionAccordion);
      });
    },
    true
  );
  document.addEventListener(
    'keydown',
    function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') {
        return;
      }
      var header =
        e.target &&
        e.target.closest &&
        e.target.closest(routeProtectionAccordionTriggerSelector());
      if (!header || !header.closest('[data-protection-widget="true"]')) {
        return;
      }
      if (e.target !== header) {
        return;
      }
      if (e.key === ' ') {
        e.preventDefault();
      }
      if (typeof header.click === 'function') {
        header.click();
      }
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(fixRouteProtectionAccordion);
      });
    },
    true
  );
}

function runA11yDomFixes() {
  hideTemplateVariantInputs();
  fixQuickBuyDrawerLiveRegion();
  applyVariantPickerOptionA11yFixes(document);
  stripScopedSectionLinkTitles();
  initSearchClearButtons(document);
  initSearchDrawerVisibleLabels(document);
  initFooterLocalizationVisibleLabels(document);
  initMappyStoreLocatorLocationVisibleLabels(document);
  ensureJudgeMeRatingStarKeyboardDelegation();
  initJudgeMeReviewFormLabels(document);
  ensurePageH1Fallback();
  fixShopHcaptchaBadgeRedundantLogoAlt();
  fixImageCarouselSlidesWithVisibleCaptions();
  fixHcaptchaResponseTextareaHidden();
  fixJudgeMeNonInteractiveTabindex();
  ensureRouteProtectionAccordionToggleSync();
  fixRouteProtectionAccordion();
}

document.addEventListener('DOMContentLoaded', runA11yDomFixes);
new MutationObserver(runA11yDomFixes).observe(document.documentElement, {
  childList: true,
  subtree: true
});

// Accessibility remediation: `quick-buy-drawer` is moved to `document.body` when open; the theme focus trap does not
// mark the rest of the page inert, so focus could reach product cards behind the overlay. While open,
// set `inert` on other `body` children. Programmatic focus on `.quick-buy-drawer__header-close` after `dialog:after-show`
// (double rAF) makes it the first focused control; visual layout uses flex `order` in `custom.css` (WCAG 2.2 2.4.3).
(function initQuickBuyDrawerA11yEnhancements() {
  var MARK = 'data-a11y-quickbuy-inert-sibling';

  function setInertOnBodySiblingsExceptDrawer(drawerEl, enable) {
    if (enable) {
      var children = document.body.children;
      for (var i = 0; i < children.length; i++) {
        var child = children[i];
        if (child === drawerEl) {
          continue;
        }
        if (child.hasAttribute(MARK)) {
          continue;
        }
        child.setAttribute(MARK, '');
        child.setAttribute('inert', '');
      }
    } else {
      document.querySelectorAll('[' + MARK + ']').forEach(function (node) {
        node.removeAttribute('inert');
        node.removeAttribute(MARK);
      });
    }
  }

  document.addEventListener('dialog:after-show', function (e) {
    if (!e.target || e.target.tagName !== 'QUICK-BUY-DRAWER' || !e.target.hasAttribute('open')) {
      return;
    }
    var drawer = e.target;
    fixQuickBuyDrawerLiveRegion();
    setInertOnBodySiblingsExceptDrawer(drawer, true);
    var closeBtn = drawer.querySelector('.quick-buy-drawer__header-close');
    if (closeBtn) {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (!drawer.hasAttribute('open')) {
            return;
          }
          applyVariantPickerOptionA11yFixes(drawer);
          closeBtn.focus({ preventScroll: true });
        });
      });
    } else {
      applyVariantPickerOptionA11yFixes(drawer);
    }
  });

  document.addEventListener('dialog:after-hide', function (e) {
    if (!e.target || e.target.tagName !== 'QUICK-BUY-DRAWER') {
      return;
    }
    setInertOnBodySiblingsExceptDrawer(null, false);
  });

  // Accessibility remediation: `option-value.liquid` outputs `tabindex="-1"` on the checked radio; after Enter/Space/click,
  // `product-rerender` can swap markup before `hideTemplateVariantInputs` runs, briefly leaving the new checked input
  // non-tabbable so Tab never returns to the picker. Re-strip `-1` on all quick-buy variant radios after `change` (sync + rAF).
  document.addEventListener(
    'change',
    function (e) {
      var t = e.target;
      if (!t || t.tagName !== 'INPUT' || t.type !== 'radio') {
        return;
      }
      if (!t.closest('variant-picker')) {
        return;
      }
      var drawer = t.closest('quick-buy-drawer[open]');
      if (!drawer) {
        return;
      }
      function healQuickBuyVariantPicker() {
        drawer.querySelectorAll('variant-picker input[type="radio"]').forEach(function (r) {
          if (r.getAttribute('tabindex') === '-1') {
            r.removeAttribute('tabindex');
          }
        });
        applyVariantPickerOptionA11yFixes(drawer);
      }
      healQuickBuyVariantPicker();
      requestAnimationFrame(function () {
        requestAnimationFrame(healQuickBuyVariantPicker);
      });
    },
    true
  );
})();

// Accessibility remediation: MOB-008 - the header navigation drawer (and the cart/search drawers, which
// share the same `Drawer` base class) trap focus via focus-trap, but the rest of the page is left
// perceivable/operable to assistive tech behind the modal overlay. On iOS VoiceOver this let swipe
// navigation escape into the page under the drawer. Mirror the proven `quick-buy-drawer` approach: while
// such a drawer is open, mark every `document.body` child `inert` EXCEPT the body-child subtree containing
// the drawer; remove it on close. The drawers differ in DOM placement: navigation-drawer is moved to
// `document.body` on open (Drawer.shouldAppendToBody), while cart-drawer (theme.js CartDrawer) and
// search-drawer (theme.js SearchDrawer) override shouldAppendToBody to false and stay nested inside their
// section wrapper -- so we resolve each drawer's body-child ANCESTOR and exclude that, never just the
// drawer node (inert inherits; inerting the ancestor would disable the open drawer itself). Removal is
// deliberately bulletproof -- keyed off any matching `after-hide` AND a `pagehide` safety net that clears
// every mark -- because a stuck `inert` would make the whole page unusable.
// WCAG 2.4.3 Focus Order (A) / 1.3.1 Info and Relationships (A).
(function initModalDrawerBackgroundInert() {
  var MARK = 'data-a11y-drawer-inert-sibling';
  var DRAWER_TAGS = { 'NAVIGATION-DRAWER': true, 'CART-DRAWER': true, 'SEARCH-DRAWER': true };

  function isTargetDrawer(el) {
    return !!(el && el.tagName && DRAWER_TAGS[el.tagName]);
  }

  function anyTargetDrawerOpen() {
    return !!document.querySelector('navigation-drawer[open], cart-drawer[open], search-drawer[open]');
  }

  function setInert(drawerEl) {
    // Resolve the element that IS the direct child of document.body for this drawer (the drawer node
    // itself for navigation-drawer, its section wrapper for the nested cart/search drawers) and exclude
    // that subtree from the inert sweep.
    var bodyChildAncestor = drawerEl;
    while (bodyChildAncestor.parentElement && bodyChildAncestor.parentElement !== document.body) {
      bodyChildAncestor = bodyChildAncestor.parentElement;
    }
    if (!bodyChildAncestor.parentElement) {
      // Drawer is detached from the document (mid-move or removed): do nothing rather than risk
      // inerting the subtree the drawer will land in.
      return;
    }
    var children = document.body.children;
    for (var i = 0; i < children.length; i++) {
      var child = children[i];
      if (child === bodyChildAncestor) {
        // Accessibility remediation: MOB-008 - the opening drawer's own subtree must never stay inert.
        // A previously opened drawer's sweep (drawer-to-drawer handoff, e.g. nav -> cart) or the
        // quick-buy pattern above may have inerted this ancestor before this drawer opened, so
        // actively strip inert here instead of merely skipping it.
        child.removeAttribute('inert');
        child.removeAttribute(MARK);
        child.removeAttribute('data-a11y-quickbuy-inert-sibling');
        continue;
      }
      if (child.hasAttribute(MARK)) {
        continue;
      }
      child.setAttribute(MARK, '');
      child.setAttribute('inert', '');
    }
  }

  function clearInert() {
    document.querySelectorAll('[' + MARK + ']').forEach(function (node) {
      node.removeAttribute('inert');
      node.removeAttribute(MARK);
    });
  }

  document.addEventListener('dialog:after-show', function (e) {
    var t = e.target;
    if (!isTargetDrawer(t) || !t.hasAttribute('open')) {
      return;
    }
    setInert(t);
  });

  document.addEventListener('dialog:after-hide', function (e) {
    if (!isTargetDrawer(e.target)) {
      return;
    }
    // Another matching drawer may still be open (e.g. cart opened from nav). Only clear when none remain.
    if (anyTargetDrawerOpen()) {
      return;
    }
    clearInert();
  });

  // Safety net: never leave the page inert across a navigation / bfcache restore.
  window.addEventListener('pagehide', clearInert);
})();

// Accessibility remediation: After add-to-cart from a collection/card `quick-buy-drawer`, the theme
// replaces the drawer with the `variant-added` confirmation ("View cart") and sets
// `blockCartDrawerOpening`, so the cart drawer never opens. Match single-variant quick add: close
// quick buy and open the cart drawer (WCAG 2.2 2.4.3 Focus Order (A) — predictable post-add focus target).
// Impact binds `_onVariantAdded` in the drawer constructor, so patching the prototype alone does not
// update listeners on drawers already on the page; re-upgrade those nodes after patching the prototype.
(function initQuickBuyOpenCartDrawerOnAdd() {
  var REUPGRADED = 'data-a11y-quickbuy-reupgraded';

  function usesCartDrawer() {
    return (
      window.themeVariables &&
      window.themeVariables.settings &&
      window.themeVariables.settings.cartType === 'drawer'
    );
  }

  function findQuickBuyDrawerInEvent(event) {
    var path = event.composedPath ? event.composedPath() : [];
    for (var i = 0; i < path.length; i++) {
      if (path[i] && path[i].tagName === 'QUICK-BUY-DRAWER') {
        return path[i];
      }
    }
    var target = event.target;
    if (target && target.closest) {
      return target.closest('quick-buy-drawer');
    }
    return null;
  }

  function openCartDrawerAfterQuickBuy(drawer) {
    if (!usesCartDrawer()) {
      return;
    }
    Promise.resolve(typeof drawer.hide === 'function' ? drawer.hide() : undefined).then(function () {
      var cartDrawer = document.getElementById('cart-drawer') || document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.show === 'function') {
        cartDrawer.show();
      }
    });
  }

  function overrideQuickBuyDrawerOnVariantAdded() {
    var Ctor = customElements.get('quick-buy-drawer');
    if (!Ctor || Ctor.__a11yQuickBuyCartFlow) {
      return !!Ctor;
    }
    Ctor.__a11yQuickBuyCartFlow = true;
    Ctor.prototype._onVariantAdded = function (event) {
      event.detail.blockCartDrawerOpening = false;
      openCartDrawerAfterQuickBuy(this);
    };
    return true;
  }

  function reupgradeQuickBuyDrawerElement(drawer) {
    if (!drawer || !drawer.parentNode || drawer.hasAttribute(REUPGRADED)) {
      return;
    }
    var parent = drawer.parentNode;
    var replacement = document.createElement('quick-buy-drawer');
    Array.prototype.forEach.call(drawer.attributes, function (attr) {
      replacement.setAttribute(attr.name, attr.value);
    });
    replacement.setAttribute(REUPGRADED, '');
    parent.replaceChild(replacement, drawer);
  }

  function reupgradeQuickBuyDrawers(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('quick-buy-drawer').forEach(reupgradeQuickBuyDrawerElement);
  }

  function installQuickBuyCartFlow() {
    if (!overrideQuickBuyDrawerOnVariantAdded()) {
      return;
    }
    reupgradeQuickBuyDrawers(document);
  }

  if (customElements.get('quick-buy-drawer')) {
    installQuickBuyCartFlow();
  } else {
    customElements.whenDefined('quick-buy-drawer').then(installQuickBuyCartFlow);
  }

  // Fallback: if the theme handler still swapped in `variant-added`, close quick buy and open cart.
  document.addEventListener('variant:add', function (event) {
    var drawer = findQuickBuyDrawerInEvent(event);
    if (!drawer || !usesCartDrawer()) {
      return;
    }
    var drawerId = drawer.id;
    event.detail.blockCartDrawerOpening = false;
    setTimeout(function () {
      var cartDrawer = document.getElementById('cart-drawer') || document.querySelector('cart-drawer');
      if (cartDrawer && cartDrawer.hasAttribute('open')) {
        return;
      }
      var activeDrawer = (drawerId && document.getElementById(drawerId)) || null;
      if (activeDrawer && activeDrawer.hasAttribute('open') && activeDrawer.querySelector('.banner--success')) {
        openCartDrawerAfterQuickBuy(activeDrawer);
        return;
      }
      if (cartDrawer && typeof cartDrawer.show === 'function') {
        cartDrawer.show();
      }
    }, 0);
  });
})();

// Accessibility remediation: Product-info rating link (stars near the title) targets
// #judgeme_product_reviews but theme.js intercepts the click with scrollIntoView only—no focus
// move. Keyboard users stay at the link while the viewport jumps. This capture-phase handler
// sets tabindex="-1" on the target container (if needed), scrolls, focuses, and updates the URL
// hash so Tab order continues from the reviews section. WCAG 2.2 2.4.3 Focus Order (A).
document.addEventListener(
  'click',
  function (event) {
    if (event.button !== 0 || event.defaultPrevented) {
      return;
    }
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }
    var link =
      event.target &&
      event.target.closest &&
      event.target.closest('.product-info__rating a[href="#judgeme_product_reviews"]');
    if (!link) {
      return;
    }
    var targetEl = document.getElementById('judgeme_product_reviews');
    if (!targetEl) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    if (targetEl.getAttribute('tabindex') === null) {
      targetEl.setAttribute('tabindex', '-1');
    }

    var scrollBehavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    targetEl.scrollIntoView({ block: 'start', behavior: scrollBehavior });
    targetEl.focus({ preventScroll: true });

    try {
      window.history.replaceState(
        null,
        '',
        window.location.pathname + window.location.search + '#judgeme_product_reviews'
      );
    } catch (e) {
      /* ignore */
    }
  },
  true
);

// Accessibility remediation: Impact theme.js delegates clicks on a[href*="#"] for smooth scroll
// and calls preventDefault without setting location/hash or moving focus. That left the skip
// link unable to update the URL and kept keyboard focus before the header. This capture-phase
// handler targets only a.skip-to-content, stops that delegate, then scrolls, focuses the target
// (tabindex -1), and history.replaceState for the hash so Tab order continues into main content.
function resolveSkipLinkHash(anchor) {
  var raw = anchor.getAttribute('href') || '';
  if (raw.charAt(0) === '#') {
    return raw;
  }
  try {
    var u = new URL(raw, window.location.href);
    if (u.pathname !== window.location.pathname || u.search !== window.location.search) {
      return '';
    }
    return u.hash || '';
  } catch (e) {
    return '';
  }
}

// Accessibility remediation: `CartDrawer._onCartChanged` (theme.js) replaces `.cart-drawer__inner`
// ~1250ms after `cart:change`, removing the focused quantity control; the drawer focus trap then lands on
// `initialFocus` (first `input` in the panel). Restore focus to the control that changed quantity (+/− button
// or number input); if that control is no longer focusable (e.g. `−` disabled at min qty), fall back to the
// line’s quantity input (WCAG 2.2 2.4.3 Focus Order (A); 2.1.1 Keyboard (A)).
(function initCartDrawerQuantityFocusRestore() {
  var pending = null;
  var restoreTimer = null;
  var INNER_UPDATE_MS = 1250;
  var RESTORE_EXTRA_MS = 80;

  function isOpenCartDrawerContext(el) {
    return !!(el && el.closest && el.closest('cart-drawer[open]'));
  }

  function capturePendingFromTarget(target) {
    if (!target || !isOpenCartDrawerContext(target)) {
      return;
    }

    var lineKey = target.getAttribute && target.getAttribute('data-line-key');
    if (!lineKey && target.closest) {
      var stepper = target.closest('.quantity-stepper');
      if (stepper) {
        var stepperInput = stepper.querySelector('.quantity-input[data-line-key]');
        lineKey = stepperInput && stepperInput.getAttribute('data-line-key');
      }
    }
    if (!lineKey) {
      return;
    }

    var kind = 'input';
    var inputId = '';
    var action = '';
    if (target.classList && target.classList.contains('quantity-stepper__btn')) {
      kind = 'stepper-btn';
      action = target.getAttribute('data-action') || '';
    } else if (target.classList && target.classList.contains('quantity-input')) {
      inputId = target.id || '';
    }

    pending = { lineKey: lineKey, kind: kind, inputId: inputId, action: action };
  }

  function pickVisibleInDrawer(drawer, nodeList) {
    for (var i = 0; i < nodeList.length; i++) {
      if (nodeList[i].offsetParent !== null) {
        return nodeList[i];
      }
    }
    return nodeList[0] || null;
  }

  function pickVisibleQuantityInput(drawer, lineKey) {
    return pickVisibleInDrawer(
      drawer,
      drawer.querySelectorAll('.quantity-input[data-line-key="' + CSS.escape(lineKey) + '"]')
    );
  }

  function pickStepperButton(drawer, lineKey, action) {
    return pickVisibleInDrawer(
      drawer,
      drawer.querySelectorAll(
        '.quantity-stepper__btn[data-line-key="' +
          CSS.escape(lineKey) +
          '"][data-action="' +
          CSS.escape(action) +
          '"]'
      )
    );
  }

  function isFocusableControl(el) {
    if (!el || typeof el.focus !== 'function') {
      return false;
    }
    if (el.disabled) {
      return false;
    }
    if (el.getAttribute('aria-hidden') === 'true') {
      return false;
    }
    var tabIndex = el.getAttribute('tabindex');
    if (tabIndex !== null && parseInt(tabIndex, 10) < 0) {
      return false;
    }
    if (el.getClientRects && el.getClientRects().length === 0) {
      return false;
    }
    return true;
  }

  function resolveRestoreTarget(drawer, restore) {
    if (restore.kind === 'stepper-btn' && restore.action) {
      var btn = pickStepperButton(drawer, restore.lineKey, restore.action);
      if (btn && isFocusableControl(btn)) {
        return btn;
      }
    }
    var input = null;
    if (restore.inputId) {
      input = document.getElementById(restore.inputId);
      if (input && !drawer.contains(input)) {
        input = null;
      }
    }
    if (!input) {
      input = pickVisibleQuantityInput(drawer, restore.lineKey);
    }
    if (input && isFocusableControl(input)) {
      return input;
    }
    return null;
  }

  function tryRestore() {
    if (!pending) {
      return false;
    }
    var drawer = document.getElementById('cart-drawer');
    if (!drawer || !drawer.hasAttribute('open')) {
      pending = null;
      return false;
    }

    var restore = pending;
    var target = resolveRestoreTarget(drawer, restore);
    if (!target) {
      return false;
    }

    pending = null;
    target.focus({ preventScroll: true });
    return true;
  }

  function scheduleRestore() {
    if (!pending) {
      return;
    }
    if (restoreTimer) {
      clearTimeout(restoreTimer);
    }
    restoreTimer = setTimeout(function () {
      restoreTimer = null;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          tryRestore();
        });
      });
    }, INNER_UPDATE_MS + RESTORE_EXTRA_MS);
  }

  document.addEventListener(
    'change',
    function (e) {
      var t = e.target;
      if (!t || t.tagName !== 'INPUT' || !t.classList.contains('quantity-input')) {
        return;
      }
      if (!t.hasAttribute('data-line-key')) {
        return;
      }
      var lineKey = t.getAttribute('data-line-key');
      // Stepper buttons dispatch `change` on the input; do not overwrite the button restore target.
      if (pending && pending.kind === 'stepper-btn' && pending.lineKey === lineKey) {
        return;
      }
      var active = document.activeElement;
      if (active && active.classList && active.classList.contains('quantity-stepper__btn')) {
        return;
      }
      capturePendingFromTarget(t);
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (e) {
      if (e.key !== 'ArrowUp' && e.key !== 'ArrowDown') {
        return;
      }
      var t = e.target;
      if (!t || t.tagName !== 'INPUT' || !t.classList.contains('quantity-input')) {
        return;
      }
      if (!t.hasAttribute('data-line-key')) {
        return;
      }
      capturePendingFromTarget(t);
    },
    true
  );

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target && e.target.closest && e.target.closest('.quantity-stepper__btn');
      if (!btn || !btn.hasAttribute('data-line-key')) {
        return;
      }
      capturePendingFromTarget(btn);
    },
    true
  );

  document.addEventListener('cart:change', function (e) {
    if (!pending || !e.detail || e.detail.baseEvent !== 'line-item:change') {
      return;
    }
    var drawer = document.getElementById('cart-drawer');
    if (!drawer || !drawer.hasAttribute('open')) {
      pending = null;
      return;
    }
    scheduleRestore();
  });

  var innerObserver = new MutationObserver(function (mutations) {
    if (!pending) {
      return;
    }
    var sawLineItems = false;
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type !== 'childList') {
        continue;
      }
      var t = m.target;
      if (
        t &&
        t.classList &&
        (t.classList.contains('cart-drawer__line-items') || t.classList.contains('cart-drawer__inner'))
      ) {
        sawLineItems = true;
        break;
      }
    }
    if (sawLineItems) {
      scheduleRestore();
    }
  });

  function hookCartDrawerInnerObserver() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) {
      return;
    }
    var inner = drawer.querySelector('.cart-drawer__inner');
    if (!inner) {
      return;
    }
    innerObserver.disconnect();
    innerObserver.observe(inner, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hookCartDrawerInnerObserver);
  } else {
    hookCartDrawerInnerObserver();
  }
  document.addEventListener('dialog:after-show', function (e) {
    if (e.target && e.target.id === 'cart-drawer') {
      hookCartDrawerInnerObserver();
    }
  });
})();

// Accessibility remediation: Route’s “See Details” modal is rendered outside `cart-drawer` while the drawer
// focus trap stays active, so focus remains in the cart panel (and Tab can dead-end after the last cart control).
// Pausing the drawer trap while `.route-modal.rm-open` and moving focus into the dialog (close control first) avoids
// fighting the vendor trap (stack overflow in `vendor.min.js`). `inert` on the open drawer keeps cart content out of
// the tab order and screen-reader browsing while the modal is open. On close, restore the trap and return focus to
// the trigger (WCAG 2.2 2.1.1 Keyboard (A); 2.4.3 Focus Order (A); 4.1.2 Name, Role, Value (A); 2.4.11 Focus Not
// Obscured (AA) when modal is open).
(function initRouteModalCartDrawerFocus() {
  var MODAL_ROOT_SELECTOR = '[data-testid="route-modal"], .route-modal';
  var DIALOG_SELECTOR = '#rm-modal-container, [data-testid="rm-modal-container"]';
  var CLOSE_SELECTOR = '[data-testid="rm-close-button"], .route-modal__close[role="button"]';
  var TRIGGER_SELECTOR =
    '#see-details-button, .pw-cashback-see-details[aria-controls="rm-modal-container"]';
  var FOCUSABLE_SELECTOR =
    'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]), [role="button"][tabindex="0"]';

  var lastTrigger = null;
  var cartTrapPaused = false;
  var tabTrapActive = false;
  var cartDrawerInerted = false;
  var focusRedirectBound = false;
  var pendingFocusTimer = null;

  function getRouteModalRoot() {
    return document.querySelector(MODAL_ROOT_SELECTOR);
  }

  function isRouteModalOpen(modal) {
    return (
      modal &&
      (modal.classList.contains('rm-open') || modal.getAttribute('aria-hidden') === 'false')
    );
  }

  function getOpenCartDrawer() {
    return document.querySelector('cart-drawer[open]');
  }

  function isFocusableControl(el) {
    if (!el || typeof el.focus !== 'function') {
      return false;
    }
    if (el.disabled) {
      return false;
    }
    if (el.getAttribute('aria-hidden') === 'true') {
      return false;
    }
    var tabIndex = el.getAttribute('tabindex');
    if (tabIndex !== null && parseInt(tabIndex, 10) < 0) {
      return false;
    }
    if (el.getClientRects && el.getClientRects().length === 0) {
      return false;
    }
    return true;
  }

  function getRouteModalFocusables(dialog) {
    if (!dialog) {
      return [];
    }
    return Array.from(dialog.querySelectorAll(FOCUSABLE_SELECTOR)).filter(function (el) {
      if (!isFocusableControl(el)) {
        return false;
      }
      var hiddenAncestor = el.closest('[aria-hidden="true"]');
      return !hiddenAncestor || hiddenAncestor === dialog;
    });
  }

  function getRouteModalInitialFocusTarget(dialog) {
    if (!dialog) {
      return null;
    }
    var close = dialog.querySelector(CLOSE_SELECTOR);
    if (close && isFocusableControl(close)) {
      return close;
    }
    var focusables = getRouteModalFocusables(dialog);
    return focusables[0] || null;
  }

  function isDialogShellFocus(el, dialog) {
    return el === dialog && dialog.getAttribute('tabindex') === '-1';
  }

  function setCartDrawerInertForRouteModal(enable) {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer || !drawer.hasAttribute('open')) {
      return;
    }
    if (enable) {
      if (!drawer.hasAttribute('inert')) {
        drawer.setAttribute('inert', '');
      }
      drawer.setAttribute('aria-hidden', 'true');
      cartDrawerInerted = true;
      return;
    }
    if (cartDrawerInerted) {
      drawer.removeAttribute('inert');
      drawer.removeAttribute('aria-hidden');
      cartDrawerInerted = false;
    }
  }

  function syncRouteModalTriggerExpanded(modal, open) {
    var trigger =
      lastTrigger ||
      document.querySelector(TRIGGER_SELECTOR + '[aria-controls="rm-modal-container"]');
    if (!trigger) {
      return;
    }
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function ensureRouteModalFocusRedirectListener() {
    if (focusRedirectBound) {
      return;
    }
    focusRedirectBound = true;
    document.addEventListener(
      'focusin',
      function (e) {
        if (!tabTrapActive) {
          return;
        }
        var modal = getRouteModalRoot();
        if (!modal || !isRouteModalOpen(modal)) {
          return;
        }
        var dialog = modal.querySelector(DIALOG_SELECTOR);
        if (!dialog || !dialog.contains(e.target)) {
          return;
        }
        if (!isDialogShellFocus(e.target, dialog)) {
          return;
        }
        var target = getRouteModalInitialFocusTarget(dialog);
        if (target) {
          target.focus({ preventScroll: true });
        }
      },
      true
    );
  }

  function pauseCartDrawerTrap() {
    var drawer = getOpenCartDrawer();
    if (!drawer || !drawer.focusTrap || cartTrapPaused) {
      return;
    }
    try {
      drawer.focusTrap.deactivate({ onDeactivate: function () {} });
      drawer.dataset.a11yRouteModalTrapPaused = '1';
      cartTrapPaused = true;
      tabTrapActive = true;
    } catch (e) {
      /* ignore */
    }
  }

  function resumeCartDrawerTrap() {
    if (!cartTrapPaused) {
      return;
    }
    var drawer = document.getElementById('cart-drawer');
    tabTrapActive = false;
    cartTrapPaused = false;
    if (drawer && drawer.hasAttribute('open') && drawer.focusTrap) {
      try {
        drawer.focusTrap.activate();
        delete drawer.dataset.a11yRouteModalTrapPaused;
      } catch (e) {
        /* ignore */
      }
    }
  }

  function focusFirstInRouteModal(modal, attempt) {
    attempt = attempt || 0;
    var dialog = modal && modal.querySelector(DIALOG_SELECTOR);
    if (!dialog) {
      return;
    }
    var target = getRouteModalInitialFocusTarget(dialog);
    if (!target) {
      if (attempt < 10) {
        setTimeout(function () {
          focusFirstInRouteModal(modal, attempt + 1);
        }, 20);
      }
      return;
    }
    target.focus({ preventScroll: true });
    var active = document.activeElement;
    var settled =
      active === target ||
      (dialog.contains(active) && !isDialogShellFocus(active, dialog) && active !== lastTrigger);
    if (!settled && attempt < 10) {
      setTimeout(function () {
        focusFirstInRouteModal(modal, attempt + 1);
      }, attempt < 4 ? 0 : 30);
    }
  }

  function closeRouteModal(modal) {
    var dialog = modal && modal.querySelector(DIALOG_SELECTOR);
    if (!dialog) {
      return false;
    }
    var close = dialog.querySelector(CLOSE_SELECTOR);
    if (!close) {
      return false;
    }
    close.click();
    return true;
  }

  function scheduleRouteModalInitialFocus(modal) {
    if (pendingFocusTimer) {
      clearTimeout(pendingFocusTimer);
      pendingFocusTimer = null;
    }
    ensureRouteModalFocusRedirectListener();
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        focusFirstInRouteModal(modal, 0);
        pendingFocusTimer = setTimeout(function () {
          pendingFocusTimer = null;
          if (isRouteModalOpen(modal)) {
            focusFirstInRouteModal(modal, 4);
          }
        }, 50);
      });
    });
  }

  function syncRouteModalState(modal) {
    if (!modal) {
      return;
    }
    if (isRouteModalOpen(modal)) {
      if (!getOpenCartDrawer()) {
        return;
      }
      pauseCartDrawerTrap();
      setCartDrawerInertForRouteModal(true);
      syncRouteModalTriggerExpanded(modal, true);
      scheduleRouteModalInitialFocus(modal);
      return;
    }
    setCartDrawerInertForRouteModal(false);
    syncRouteModalTriggerExpanded(modal, false);
    if (cartTrapPaused) {
      var trigger = lastTrigger;
      resumeCartDrawerTrap();
      if (trigger && isFocusableControl(trigger)) {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            if (isRouteModalOpen(modal)) {
              return;
            }
            trigger.focus({ preventScroll: true });
          });
        });
      }
      lastTrigger = null;
    }
  }

  function bindRouteModalObserver(modal) {
    if (!modal || modal.dataset.a11yRouteModalObs === '1') {
      return;
    }
    modal.dataset.a11yRouteModalObs = '1';
    new MutationObserver(function () {
      syncRouteModalState(modal);
    }).observe(modal, { attributes: true, attributeFilter: ['class', 'aria-hidden'] });
    syncRouteModalState(modal);
  }

  function scanForRouteModal() {
    var modal = getRouteModalRoot();
    if (modal) {
      bindRouteModalObserver(modal);
    }
  }

  document.addEventListener(
    'click',
    function (e) {
      var trigger = e.target && e.target.closest && e.target.closest(TRIGGER_SELECTOR);
      if (!trigger || !getOpenCartDrawer()) {
        return;
      }
      lastTrigger = trigger;
    },
    true
  );

  document.addEventListener('dialog:after-hide', function (e) {
    if (!e.target || e.target.id !== 'cart-drawer') {
      return;
    }
    cartTrapPaused = false;
    tabTrapActive = false;
    cartDrawerInerted = false;
    delete e.target.dataset.a11yRouteModalTrapPaused;
    e.target.removeAttribute('inert');
    e.target.removeAttribute('aria-hidden');
  });

  document.addEventListener(
    'keydown',
    function (e) {
      if (e.key === 'Escape' || e.code === 'Escape') {
        var escapeModal = getRouteModalRoot();
        if (escapeModal && isRouteModalOpen(escapeModal)) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          closeRouteModal(escapeModal);
        }
        return;
      }
      if (e.key !== 'Tab' || !tabTrapActive) {
        return;
      }
      var modal = getRouteModalRoot();
      if (!modal || !isRouteModalOpen(modal)) {
        return;
      }
      var dialog = modal.querySelector(DIALOG_SELECTOR);
      if (!dialog) {
        return;
      }
      var focusables = getRouteModalFocusables(dialog);
      if (!focusables.length) {
        return;
      }
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      var active = document.activeElement;
      if (isDialogShellFocus(active, dialog)) {
        e.preventDefault();
        first.focus({ preventScroll: true });
        return;
      }
      if (e.shiftKey) {
        if (active === first || !dialog.contains(active)) {
          e.preventDefault();
          last.focus({ preventScroll: true });
        }
      } else if (active === last || !dialog.contains(active)) {
        e.preventDefault();
        first.focus({ preventScroll: true });
      }
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanForRouteModal);
  } else {
    scanForRouteModal();
  }
  new MutationObserver(scanForRouteModal).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();

document.addEventListener(
  'click',
  function (event) {
    if (event.button !== 0 || event.defaultPrevented) {
      return;
    }
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }
    var skip = event.target && event.target.closest && event.target.closest('a.skip-to-content');
    if (!skip) {
      return;
    }
    var hash = resolveSkipLinkHash(skip);
    if (!hash || hash.length < 2) {
      return;
    }
    var id = hash.slice(1);
    var targetEl = document.getElementById(id);
    if (!targetEl) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    targetEl.setAttribute('tabindex', '-1');

    var scrollBehavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    targetEl.scrollIntoView({ block: 'start', behavior: scrollBehavior });
    targetEl.focus({ preventScroll: true });

    try {
      window.history.replaceState(null, '', window.location.pathname + window.location.search + hash);
    } catch (e) {
      /* ignore */
    }
  },
  true
);

// Accessibility remediation: MOB-002 - `DialogElement` (theme.js) sets `role="dialog"` + `aria-modal` on every
// drawer/popover but never a name, so unnamed dialogs announced only as "dialog". cart-drawer / search-drawer are
// named in Liquid (host `aria-label`); this pass covers the rest that are created/authored outside the files in scope:
// `quick-buy-drawer` (vendor-created from a <template>; named from its header product-title link) and `x-popover`
// (`Popover extends DialogElement`, so also `role="dialog"`; named from the accessible name of the `[aria-controls]`
// control that opens it). Runs on `dialog:after-show`, idempotent, and never overrides a name the theme/Liquid already
// set. WCAG 2.2 4.1.2 Name, Role, Value (A).
(function initDialogAccessibleNames() {
  if (typeof document === 'undefined') {
    return;
  }

  function alreadyNamed(el) {
    return (
      (el.getAttribute('aria-label') || '').trim() !== '' ||
      (el.getAttribute('aria-labelledby') || '').trim() !== ''
    );
  }

  function a11yDialogUniqueId(base) {
    var candidate = base;
    var n = 0;
    while (document.getElementById(candidate)) {
      n += 1;
      candidate = base + '-' + n;
    }
    return candidate;
  }

  function controlAccessibleName(dialog) {
    if (!dialog.id) {
      return '';
    }
    var controls = document.querySelectorAll('[aria-controls="' + CSS.escape(dialog.id) + '"]');
    for (var i = 0; i < controls.length; i++) {
      var c = controls[i];
      var name = (c.getAttribute('aria-label') || '').trim();
      if (!name) {
        name = (c.textContent || '').replace(/\s+/g, ' ').trim();
      }
      if (name) {
        return name;
      }
    }
    return '';
  }

  function nameQuickBuyDrawer(dialog) {
    // Prefer the visible product-title link in the quick-buy header (more meaningful than the card trigger).
    var titleLink =
      dialog.querySelector('.quick-buy-drawer__header-main a.bold') ||
      dialog.querySelector('.quick-buy-drawer__header-row a.bold');
    if (titleLink && (titleLink.textContent || '').trim()) {
      if (!titleLink.id) {
        titleLink.id = a11yDialogUniqueId('a11y-quick-buy-title');
      }
      if (dialog.getAttribute('aria-labelledby') !== titleLink.id) {
        dialog.setAttribute('aria-labelledby', titleLink.id);
      }
      return true;
    }
    return false;
  }

  function nameDialog(dialog) {
    if (!dialog || dialog.getAttribute('role') !== 'dialog' || alreadyNamed(dialog)) {
      return;
    }
    if (dialog.tagName === 'QUICK-BUY-DRAWER' && nameQuickBuyDrawer(dialog)) {
      return;
    }
    var name = controlAccessibleName(dialog);
    if (name) {
      dialog.setAttribute('aria-label', name);
    }
  }

  document.addEventListener('dialog:after-show', function (e) {
    var t = e.target;
    if (t && t.getAttribute && t.getAttribute('role') === 'dialog') {
      nameDialog(t);
    }
  });
})();

// Accessibility remediation: MOB-003 - the theme focus-trap only auto-focuses on `pointer:fine` and its return-focus
// target is whatever was focused at activation time. On touch/webkit the drawer trigger is activated by tap without
// receiving focus, so on close focus-trap returns to `document.body`. Record the `[aria-controls]` control that
// activated each drawer/dialog (capture-phase click + keydown), and on `dialog:after-hide` focus that control when the
// trap left focus on `body`/detached/inside the closed dialog. Deliberately defers to the existing Route-modal handler
// (which owns cart-drawer trigger refocus while its modal round-trips) by skipping while a Route modal is open, and does
// not fight quick-buy (that flow closes into the cart drawer). WCAG 2.2 2.4.3 Focus Order (A).
(function initDialogReturnFocusOnClose() {
  if (typeof document === 'undefined') {
    return;
  }
  var triggers = {};

  function isRouteModalOpen() {
    var modal = document.querySelector('[data-testid="route-modal"], .route-modal');
    return !!(
      modal &&
      (modal.classList.contains('rm-open') || modal.getAttribute('aria-hidden') === 'false')
    );
  }

  function recordTrigger(control) {
    if (!control || !control.getAttribute) {
      return;
    }
    var id = control.getAttribute('aria-controls');
    if (!id) {
      return;
    }
    // Only track controls that point at an actual dialog element.
    var target = document.getElementById(id);
    if (!target || target.getAttribute('role') !== 'dialog') {
      return;
    }
    triggers[id] = control;
  }

  function isFocusable(el) {
    if (!el || typeof el.focus !== 'function') {
      return false;
    }
    if (el.disabled || el.getAttribute('aria-hidden') === 'true') {
      return false;
    }
    var ti = el.getAttribute('tabindex');
    if (ti !== null && parseInt(ti, 10) < 0) {
      return false;
    }
    if (el.getClientRects && el.getClientRects().length === 0) {
      return false;
    }
    return true;
  }

  document.addEventListener(
    'click',
    function (e) {
      var control =
        e.target && e.target.closest && e.target.closest('[aria-controls]');
      if (control) {
        recordTrigger(control);
      }
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') {
        return;
      }
      var control =
        e.target && e.target.closest && e.target.closest('[aria-controls]');
      if (control) {
        recordTrigger(control);
      }
    },
    true
  );

  document.addEventListener('dialog:after-hide', function (e) {
    var dialog = e.target;
    if (!dialog || !dialog.id || dialog.getAttribute('role') !== 'dialog') {
      return;
    }
    var control = triggers[dialog.id];
    if (!control) {
      return;
    }
    delete triggers[dialog.id];

    // The Route-modal handler restores the cart-drawer trigger itself; do not compete while it is open.
    if (isRouteModalOpen()) {
      return;
    }

    // Only step in when the trap did not return focus to a real, still-connected control: activeElement is body/null,
    // detached, or still inside the now-closed dialog.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (isRouteModalOpen()) {
          return;
        }
        var active = document.activeElement;
        var trapReturnedSomewhere =
          active &&
          active !== document.body &&
          active.isConnected &&
          !dialog.contains(active) &&
          typeof active.focus === 'function';
        if (trapReturnedSomewhere) {
          return;
        }
        if (isFocusable(control) && control.isConnected) {
          control.focus({ preventScroll: true });
        }
      });
    });
  });
})();

// Accessibility remediation: MOB-009 / MOB-011 - the cart drawer shipped with zero live regions, so subtotal/count,
// discount, and removal changes were silent, and removing a line dropped focus to `<body>`. This injects ONE persistent
// polite `role="status"` region as a direct child of `<cart-drawer>` (re-injected after any theme replaceChildren, since
// no Liquid child survives the empty-cart/full-refresh swaps) and, on each `cart:change`, composes a SINGLE debounced
// message (never one per field): item count + total, plus discount applied/removed, plus "item removed" on a line
// removal. The first observed cart state is captured WITHOUT announcing (no initial-render spam). On removal it also
// moves focus to the next line's remove control (or the cart heading / continue-shopping button when the cart empties),
// coexisting with the existing quantity focus-restore (that only fires for `line-item:change` quantity edits, not
// removals). Reuses the theme's own `cart:change` event and localized strings exposed as `data-a11y-*` on the host.
// WCAG 2.2 4.1.3 Status Messages (AA), 4.1.2 Name, Role, Value (A), 2.4.3 Focus Order (A).
(function initCartDrawerAnnouncements() {
  if (typeof document === 'undefined') {
    return;
  }
  var REGION_MARK = 'data-a11y-cart-live-region';
  var snapshot = null; // { itemCount, discountCodes: [lowercased] }
  var announceTimer = null;

  function getDrawer() {
    return document.getElementById('cart-drawer') || document.querySelector('cart-drawer');
  }

  function ensureRegion() {
    var drawer = getDrawer();
    if (!drawer) {
      return null;
    }
    var region = drawer.querySelector('[' + REGION_MARK + ']');
    if (region && region.parentNode === drawer) {
      return region;
    }
    // Region missing or was moved inside a subtree that gets replaced: (re)create as a direct host child.
    region = document.createElement('span');
    region.setAttribute(REGION_MARK, '');
    region.className = 'sr-only';
    region.setAttribute('role', 'status');
    region.setAttribute('aria-live', 'polite');
    region.setAttribute('aria-atomic', 'true');
    drawer.appendChild(region);
    return region;
  }

  function announce(message) {
    if (!message) {
      return;
    }
    var region = ensureRegion();
    if (!region) {
      return;
    }
    // Clear then set on the next frame so repeated identical messages are still re-announced.
    region.textContent = '';
    window.requestAnimationFrame(function () {
      region.textContent = message;
    });
  }

  function readTotalText() {
    var el = document.querySelector('#cart-drawer .cart-total-price');
    return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }

  function composeCountTotal(cart) {
    var drawer = getDrawer();
    if (!drawer) {
      return '';
    }
    var tpl = drawer.getAttribute('data-a11y-cart-status-template') || '';
    if (!tpl) {
      return '';
    }
    var count = cart && typeof cart.item_count === 'number' ? cart.item_count : null;
    if (count === null) {
      return '';
    }
    var total = readTotalText();
    return tpl.replace('%COUNT%', String(count)).replace('%TOTAL%', total);
  }

  function discountCodesFromCart(cart) {
    var out = [];
    if (cart && Array.isArray(cart.discount_codes)) {
      for (var i = 0; i < cart.discount_codes.length; i++) {
        var d = cart.discount_codes[i];
        if (d && d.applicable && d.code) {
          out.push(String(d.code).toLowerCase());
        }
      }
    }
    return out;
  }

  function diffDiscountMessage(drawer, prevCodes, nextCodes) {
    var added = nextCodes.filter(function (c) {
      return prevCodes.indexOf(c) === -1;
    });
    var removed = prevCodes.filter(function (c) {
      return nextCodes.indexOf(c) === -1;
    });
    if (added.length) {
      return drawer.getAttribute('data-a11y-discount-applied') || '';
    }
    if (removed.length) {
      return drawer.getAttribute('data-a11y-discount-removed') || '';
    }
    return '';
  }

  function focusAfterRemoval() {
    var drawer = getDrawer();
    if (!drawer || !drawer.hasAttribute('open')) {
      return;
    }
    // Empty cart: theme swaps in the empty-state. Focus its heading or the continue-shopping button.
    if (!drawer.querySelector('.cart-drawer__line-items')) {
      var emptyTarget =
        drawer.querySelector('.empty-state a, .empty-state [is="close-button"]') ||
        drawer.querySelector('h2');
      if (emptyTarget) {
        if (emptyTarget.tagName === 'H2' && emptyTarget.getAttribute('tabindex') === null) {
          emptyTarget.setAttribute('tabindex', '-1');
        }
        emptyTarget.focus({ preventScroll: true });
      }
      return;
    }
    // Otherwise focus the first remaining remove control (the remove links live inside <line-item-quantity>). Prefer a
    // visible one, since each line renders both a mobile and a desktop copy.
    var removeLinks = drawer.querySelectorAll('.cart-drawer__line-items line-item line-item-quantity a.link');
    var remove = null;
    for (var i = 0; i < removeLinks.length; i++) {
      if (removeLinks[i].offsetParent !== null) {
        remove = removeLinks[i];
        break;
      }
    }
    if (!remove && removeLinks.length) {
      remove = removeLinks[0];
    }
    if (remove && typeof remove.focus === 'function') {
      remove.focus({ preventScroll: true });
    }
  }

  document.addEventListener('cart:change', function (e) {
    if (!e.detail || !e.detail.cart) {
      return;
    }
    var cart = e.detail.cart;
    var drawer = getDrawer();
    if (!drawer) {
      return;
    }
    var nextCount = typeof cart.item_count === 'number' ? cart.item_count : null;
    var nextCodes = discountCodesFromCart(cart);

    // First observation establishes the baseline WITHOUT announcing (no initial-render spam).
    if (snapshot === null) {
      snapshot = { itemCount: nextCount, discountCodes: nextCodes };
      return;
    }

    var prev = snapshot;
    snapshot = { itemCount: nextCount, discountCodes: nextCodes };

    // Only announce cart changes while the drawer is actually open (perceivable context).
    if (!drawer.hasAttribute('open')) {
      return;
    }

    // Add-to-cart is owned by the MOB-032 "Added to cart: <title>" announcement; do not also speak the count/total here
    // (that would double-announce on two different live regions). Snapshot is still updated above so later diffs stay
    // correct.
    if (e.detail.baseEvent === 'variant:add') {
      return;
    }

    var isRemoval =
      e.detail.baseEvent === 'line-item:change' &&
      prev.itemCount !== null &&
      nextCount !== null &&
      nextCount < prev.itemCount;

    // Compose ONE message; debounce rapid successive mutations.
    if (announceTimer) {
      clearTimeout(announceTimer);
    }
    announceTimer = setTimeout(function () {
      announceTimer = null;
      var parts = [];
      var discountMsg = diffDiscountMessage(drawer, prev.discountCodes, nextCodes);
      if (discountMsg) {
        parts.push(discountMsg);
      }
      if (isRemoval) {
        var removedMsg = drawer.getAttribute('data-a11y-item-removed') || '';
        if (removedMsg) {
          parts.push(removedMsg);
        }
      }
      var countTotal = composeCountTotal(cart);
      if (countTotal) {
        parts.push(countTotal);
      }
      announce(parts.join('. '));
    }, 250);

    // MOB-011: after the theme finishes the removal animation + inner re-render, move focus off <body>.
    if (isRemoval) {
      // Empty-cart path re-renders immediately; line removal animates ~200ms then re-renders inner ~1250ms later.
      var delay = nextCount === 0 ? 260 : 1350;
      setTimeout(function () {
        requestAnimationFrame(function () {
          var active = document.activeElement;
          // Only intervene if focus was actually lost to body/detached (do not steal deliberate focus).
          if (!active || active === document.body || !active.isConnected) {
            focusAfterRemoval();
          }
        });
      }, delay);
    }
  });

  // Keep the region present across shows / re-renders, and seed the baseline from the rendered count so the FIRST
  // change after opening announces (rather than being consumed as the baseline).
  document.addEventListener('dialog:after-show', function (e) {
    if (!e.target || e.target.id !== 'cart-drawer') {
      return;
    }
    ensureRegion();
    if (snapshot === null) {
      var countEl = e.target.querySelector('cart-count');
      var seededCount = countEl ? parseInt((countEl.textContent || '').trim(), 10) : NaN;
      snapshot = {
        itemCount: isNaN(seededCount) ? null : seededCount,
        discountCodes: []
      };
    }
  });
})();

// Accessibility remediation: MOB-030 / MOB-032 - variant changes on the main PDP re-rendered price/availability
// silently, and Add-to-Cart gave no screen-reader confirmation. MOB-030: on the theme's `variant:change` event, read
// the freshly re-rendered price text from the persistent sr-only status region's `data-a11y-price-selector` target
// (reusing the theme's own localized/formatted price rather than formatting money in JS) plus availability from
// `event.detail.variant.available`, and announce "<price>, <availability>" into that region (which lives OUTSIDE the
// swapped price block). MOB-032: on `variant:add`, announce "Added to cart: <title>" via a shared page-level polite
// region, using the localized template on `<buy-buttons>`. Announcements are debounced and never fire on initial
// render. WCAG 2.2 4.1.3 Status Messages (AA).
(function initProductAnnouncements() {
  if (typeof document === 'undefined') {
    return;
  }
  var SHARED_MARK = 'data-a11y-shared-live-region';
  var variantTimer = null;

  // Accessibility remediation: MOB-030 polish - the price element concatenates child spans without
  // whitespace (sr-only "Sale price" + "$105.00" read as "Sale price$105.00" on VoiceOver, iOS Gate-B
  // row 9 cosmetic note). Join text at element boundaries with a space instead of using raw textContent.
  function readTextSpaced(el) {
    if (!el) {
      return '';
    }
    var parts = [];
    (function walk(node) {
      for (var i = 0; i < node.childNodes.length; i++) {
        var child = node.childNodes[i];
        if (child.nodeType === 3) {
          var t = child.textContent.replace(/\s+/g, ' ').trim();
          if (t) {
            parts.push(t);
          }
        } else if (child.nodeType === 1) {
          walk(child);
        }
      }
    })(el);
    return parts.join(' ');
  }

  function getSharedRegion() {
    var region = document.querySelector('[' + SHARED_MARK + ']');
    if (region) {
      return region;
    }
    region = document.createElement('span');
    region.setAttribute(SHARED_MARK, '');
    region.className = 'sr-only';
    region.setAttribute('role', 'status');
    region.setAttribute('aria-live', 'polite');
    region.setAttribute('aria-atomic', 'true');
    document.body.appendChild(region);
    return region;
  }

  function announceShared(message) {
    if (!message) {
      return;
    }
    var region = getSharedRegion();
    region.textContent = '';
    window.requestAnimationFrame(function () {
      region.textContent = message;
    });
  }

  function announceInVariantRegion(region, message) {
    if (!region || !message) {
      return;
    }
    region.textContent = '';
    window.requestAnimationFrame(function () {
      region.textContent = message;
    });
  }

  // MOB-030: main PDP variant change.
  document.addEventListener('variant:change', function (e) {
    var detail = e.detail || {};
    var variant = detail.variant || null;
    // Scope to the form that changed: the status region only exists for the main product context, and must belong to
    // the SAME product-rerender subtree as the changing form (so a quick-buy variant change never announces the main
    // product's price, and multi-product pages announce the right one).
    var formId = detail.formId || '';
    var form = formId ? document.getElementById(formId) : null;
    if (!form) {
      return;
    }
    if (form.closest && form.closest('quick-buy-drawer')) {
      return;
    }
    var scope = (form.closest && form.closest('product-rerender')) || document;
    var region = scope.querySelector('[data-a11y-variant-status]') || null;
    if (!region) {
      return;
    }
    var tpl = region.getAttribute('data-a11y-status-template') || '';
    if (!tpl) {
      return;
    }

    if (variantTimer) {
      clearTimeout(variantTimer);
    }
    // Defer so the `product:rerender` swap (dispatched just before `variant:change`) has painted the new price.
    variantTimer = setTimeout(function () {
      variantTimer = null;
      var priceSelector = region.getAttribute('data-a11y-price-selector') || '';
      var priceScope = (region.closest && region.closest('product-rerender')) || document;
      var priceEl = priceSelector ? priceScope.querySelector(priceSelector) : null;
      var priceText = readTextSpaced(priceEl);
      var available = variant ? variant.available !== false : true;
      var availabilityText = available
        ? region.getAttribute('data-a11y-in-stock') || ''
        : region.getAttribute('data-a11y-out-of-stock') || '';
      var message = tpl
        .replace('%PRICE%', priceText)
        .replace('%AVAILABILITY%', availabilityText)
        .replace(/^[\s,]+|[\s,]+$/g, '');
      announceInVariantRegion(region, message);
    }, 120);
  });

  // Accessibility remediation: MOB-030 - fallback for variant pickers that re-render WITHOUT dispatching the
  // theme's `variant:change` CustomEvent. Live-confirmed 2026-07-07 on the gift-card PDP: a real denomination
  // click produces only the radios' native `change` events plus a DOM swap of the price - no variant:change or
  // product:rerender ever reaches the document, so the listener above never runs on that path. Trigger from the
  // native `change` event instead (document capture), wait for the swapped price text to actually change (bounded
  // poll), and derive availability from the add-to-cart button's disabled state since no variant payload exists.
  // Shares the same debounce timer as the variant:change path so one selection can never announce twice.
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('variant-picker input[type="radio"]')) {
      return;
    }
    if (input.closest('quick-buy-drawer')) {
      return;
    }
    var scope = input.closest('product-rerender') || input.closest('product-info, .product-info') || document;
    var region = scope.querySelector('[data-a11y-variant-status]');
    if (!region) {
      // Region only exists for the main product context; card/drawer pickers stay silent by design.
      return;
    }
    var tpl = region.getAttribute('data-a11y-status-template') || '';
    var priceSelector = region.getAttribute('data-a11y-price-selector') || '';
    if (!tpl || !priceSelector) {
      return;
    }
    var priceScope = region.closest('product-rerender') || scope;
    var readPrice = function () {
      var el = priceScope.querySelector(priceSelector);
      if (!el && scope !== document) {
        el = scope.querySelector(priceSelector);
      }
      return readTextSpaced(el);
    };
    var priceBefore = readPrice();
    if (variantTimer) {
      clearTimeout(variantTimer);
    }
    var attempts = 0;
    var poll = function () {
      variantTimer = null;
      attempts += 1;
      var priceText = readPrice();
      if (priceText === priceBefore && attempts < 8) {
        // Swap has not painted yet - keep waiting (max ~1.2s), then announce regardless (the
        // selection changed even if the price happens to be identical across variants).
        variantTimer = setTimeout(poll, 150);
        return;
      }
      var atc = scope.querySelector('buy-buttons button[type="submit"], form[action*="/cart/add"] button[type="submit"], button[name="add"]');
      var available = !(atc && (atc.disabled || atc.getAttribute('aria-disabled') === 'true'));
      var availabilityText = available
        ? region.getAttribute('data-a11y-in-stock') || ''
        : region.getAttribute('data-a11y-out-of-stock') || '';
      var message = tpl
        .replace('%PRICE%', priceText)
        .replace('%AVAILABILITY%', availabilityText)
        .replace(/^[\s,]+|[\s,]+$/g, '');
      announceInVariantRegion(region, message);
    };
    variantTimer = setTimeout(poll, 150);
  }, true);

  // MOB-032: successful add-to-cart.
  document.addEventListener('variant:add', function (e) {
    var detail = e.detail || {};
    var items = detail.items || [];
    if (!items.length) {
      return;
    }
    var tplHost = document.querySelector('[data-a11y-added-to-cart-template]');
    var tpl = tplHost ? tplHost.getAttribute('data-a11y-added-to-cart-template') : '';
    if (!tpl) {
      return;
    }
    var title =
      items[0].product_title ||
      items[0].title ||
      items[0].product_name ||
      '';
    if (!title) {
      return;
    }
    announceShared(tpl.replace('%TITLE%', String(title).replace(/\s+/g, ' ').trim()));
  });
})();

// Accessibility remediation: MOB-014 - on combined-listing products, selecting a variant option renders as a
// full-page navigation to the connected product URL (option-value.liquid emits `<a href>` swatches in the
// variant-picker when `reload_page_for_combined_products`). After the reload the browser resets scroll to the top
// and focus to <body>, so a keyboard/AT user who just chose an option is dumped at the page start with no idea the
// selection took effect (WCAG 2.2 2.4.3 Focus Order (A), best practice). Fix: when such a link is activated, record
// the destination pathname in sessionStorage; on the next load, if the flag matches the current page, move focus
// back to the variant picker (its fieldset/legend or the selected control) so context is restored. The flag is
// consumed immediately (fresh-only) and we never call preventDefault/stopPropagation, so the theme's own
// navigation/hash handling is untouched.
(function initCombinedListingVariantFocusRestore() {
  if (typeof document === 'undefined' || typeof window === 'undefined') {
    return;
  }
  var FLAG_KEY = 'a11y-variant-nav-restore';

  function isProductContext() {
    return !!document.querySelector('variant-picker');
  }

  // Stable selector: URL-nav options render as anchors carrying the swatch/thumbnail/block classes inside the
  // variant picker (see snippets/option-value.liquid). Restrict to anchors with an href so labels/spans are ignored.
  var OPTION_LINK_SELECTOR =
    'variant-picker a[href].color-swatch,' +
    'variant-picker a[href].block-swatch,' +
    'variant-picker a[href].thumbnail-swatch,' +
    'variant-picker a[href].image-filter,' +
    'product-info a[href].color-swatch,' +
    'product-info a[href].block-swatch,' +
    'product-info a[href].thumbnail-swatch';

  function destinationPathname(link) {
    try {
      return new URL(link.getAttribute('href'), window.location.href).pathname;
    } catch (err) {
      return '';
    }
  }

  document.addEventListener(
    'click',
    function (e) {
      var link = e.target && e.target.closest && e.target.closest(OPTION_LINK_SELECTOR);
      if (!link || e.defaultPrevented) {
        return;
      }
      var path = destinationPathname(link);
      if (!path) {
        return;
      }
      try {
        sessionStorage.setItem(FLAG_KEY, path);
      } catch (err) {
        /* ignore quota/private-mode */
      }
    },
    true
  );

  function focusVariantPickerOnRestore() {
    if (!isProductContext()) {
      return;
    }
    var flag = null;
    try {
      flag = sessionStorage.getItem(FLAG_KEY);
    } catch (err) {
      return;
    }
    if (!flag) {
      return;
    }
    // Consume immediately so a later normal load never re-triggers a focus jump.
    try {
      sessionStorage.removeItem(FLAG_KEY);
    } catch (err) {
      /* ignore */
    }
    if (flag !== window.location.pathname) {
      return;
    }
    var picker = document.querySelector('variant-picker');
    if (!picker) {
      return;
    }
    // Prefer the currently-selected option control, then the group legend, then the picker itself.
    var target =
      picker.querySelector('.is-selected a, .is-selected, [aria-current="true"]') ||
      picker.querySelector('legend') ||
      picker;
    if (!target) {
      return;
    }
    if (!target.hasAttribute('tabindex') && target.tagName !== 'A' && target.tagName !== 'BUTTON') {
      // Make a non-interactive legend/host focusable without adding it to the tab order.
      target.setAttribute('tabindex', '-1');
    }
    if (typeof target.focus !== 'function') {
      return;
    }
    // Accessibility remediation: MOB-014 round-2 hardening - a single rAF focus at DOMContentLoaded loses
    // the race against Safari's own load-time scroll/focus settling on FIRST-VISIT destinations (iOS Gate-B
    // round 2: size-variant navs, whose destinations were bfcached from earlier browsing, restored fine;
    // color-variant navs to fresh pages landed at the top). Re-assert the focus at load and on timed
    // retries, but only while nothing else has claimed focus (activeElement still on body) so we never
    // fight the user or another script.
    var attemptFocus = function () {
      try {
        target.focus({ preventScroll: false });
      } catch (err) {
        /* ignore */
      }
    };
    window.requestAnimationFrame(attemptFocus);
    var reassert = function () {
      if (document.activeElement === document.body || document.activeElement === null || document.activeElement === document.documentElement) {
        attemptFocus();
      }
    };
    if (document.readyState !== 'complete') {
      window.addEventListener('load', function () {
        window.requestAnimationFrame(reassert);
      }, { once: true });
    }
    setTimeout(reassert, 400);
    setTimeout(reassert, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', focusVariantPickerOnRestore);
  } else {
    focusVariantPickerOnRestore();
  }
})();

// Accessibility remediation: MOB-018 - the logo list (`sections/logo-list.liquid`) renders as
// `<reveal-items class="logo-list scroll-area bleed sm:unbleed">`, a horizontal scroll region, when
// "Stack on mobile" is off. Native horizontal scroll containers have no keyboard affordance, so a keyboard-only
// user cannot reach logos scrolled off-screen (WCAG 2.2 2.1.1 Keyboard (A)). The Liquid now exposes the element as
// a focusable labelled group (`tabindex="0" role="group" aria-label`); this handler adds Left/Right arrow scrolling
// (~80% of the visible width per press). Scoped to `.logo-list.scroll-area`; reduced-motion users get an instant
// jump instead of a smooth scroll.
(function initLogoListKeyboardScroll() {
  if (typeof document === 'undefined' || typeof window === 'undefined') {
    return;
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') {
      return;
    }
    var region = e.target && e.target.closest && e.target.closest('.logo-list.scroll-area');
    if (!region) {
      return;
    }
    // Only act when the region itself holds focus, so arrow keys inside a focused child link are not hijacked.
    if (e.target !== region) {
      return;
    }
    e.preventDefault();
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var amount = Math.max(1, Math.round(region.clientWidth * 0.8));
    region.scrollBy({
      left: e.key === 'ArrowRight' ? amount : -amount,
      behavior: reduce ? 'auto' : 'smooth'
    });
  });
})();

// Accessibility remediation: REG-05 - inside the OPEN nav drawer, inactive panels are hidden only by
// panel-level inline visibility/opacity (their `.panel__wrapper`s are NOT [hidden]), and the MOB-007/REG-02
// floors on the wrappers' `li`s resurrect those descendants: with the Shop submenu shown, the main menu's
// links were invisible (ancestor opacity:0) yet still TAB-reachable - keyboard focus fell out of the end of
// the submenu into off-screen main-menu items with no visual panel switch (client-reported 2026-07-08; live
// probe measured 7 tabbable controls inside the hidden panel). Sync `inert` onto whichever `.panel`s are in
// the hidden steady-state so inactive panels drop out of the tab order and the AT tree entirely; the target
// panel is un-inerted the moment its opener/back button is pressed so the theme's animation and the MOB-001
// focus move are never blocked. WCAG 2.2 2.4.3 Focus Order (A) / 1.3.2 (A).
(function initNavDrawerPanelInertSync() {
  if (typeof document === 'undefined') {
    return;
  }
  var DRAWER_SELECTOR = 'navigation-drawer#header-sidebar-menu';
  var settleTimer = null;

  function getDrawer() {
    return document.querySelector(DRAWER_SELECTOR + '[open]');
  }

  function syncFromComputedState() {
    settleTimer = null;
    var drawer = getDrawer();
    if (!drawer) {
      return;
    }
    var panels = drawer.querySelectorAll('.panel');
    for (var i = 0; i < panels.length; i++) {
      var hidden = getComputedStyle(panels[i]).visibility === 'hidden';
      // Never inert a panel that currently contains focus (mid-transition safety).
      if (hidden && panels[i].contains(document.activeElement)) {
        hidden = false;
      }
      if (hidden) {
        panels[i].setAttribute('inert', '');
      } else {
        panels[i].removeAttribute('inert');
      }
    }
  }

  function scheduleSettleSync() {
    if (settleTimer) {
      clearTimeout(settleTimer);
    }
    // The panel stagger runs ~500ms; sync once the steady-state visibility values are in place.
    settleTimer = setTimeout(syncFromComputedState, 700);
  }

  function clearAll() {
    var drawer = document.querySelector(DRAWER_SELECTOR);
    if (!drawer) {
      return;
    }
    var panels = drawer.querySelectorAll('.panel[inert]');
    for (var i = 0; i < panels.length; i++) {
      panels[i].removeAttribute('inert');
    }
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target && e.target.closest && e.target.closest(DRAWER_SELECTOR + '[open] button[data-panel]');
      if (!btn) {
        return;
      }
      // Un-inert the destination panel immediately so the theme's switch animation and focus move work.
      var drawer = getDrawer();
      var idx = parseInt((btn.getAttribute('data-panel') || '').split('-')[0], 10);
      if (drawer && !isNaN(idx)) {
        var panels = drawer.querySelectorAll('.panel');
        if (panels[idx]) {
          panels[idx].removeAttribute('inert');
        }
      }
      scheduleSettleSync();
    },
    true
  );

  document.addEventListener('dialog:after-show', function (e) {
    if (e.target && e.target.matches && e.target.matches(DRAWER_SELECTOR)) {
      scheduleSettleSync();
    }
  });

  document.addEventListener('dialog:after-hide', function (e) {
    if (e.target && e.target.matches && e.target.matches(DRAWER_SELECTOR)) {
      if (settleTimer) {
        clearTimeout(settleTimer);
        settleTimer = null;
      }
      clearAll();
    }
  });
})();

// Accessibility remediation: third-party overlay guards (Attentive/Tydal, client-authorized good-faith
// 2026-07-08). Two vendor sign-up popups inject a `position: fixed`, `z-index: 2147483647` full-viewport
// iframe onto the host page that the theme cannot reach through Liquid, so they are remediated here as a
// last resort. This is a single shared engine driving two per-vendor descriptors; it mirrors the proven
// defensive style of `initModalDrawerBackgroundInert` (body-sibling `inert` sweep with bulletproof removal),
// the Route app-injected observer (documentElement childList watch + per-node MutationObserver + debounce),
// and the `pagehide` safety net, but is written as an independent, light version scoped to these overlays.
//
// ATTENTIVE (ACTIVE on live/staging, live-audited 2026-07-08): while OPEN, `#attentive_creative` (iframe,
// title "Sign Up via Text for Offers") is a full-viewport interceptor inside `#attentive_overlay`. Three
// defects are remediated: (1) no dialog semantics -> stamp `role="dialog"` + `aria-modal="true"` on the
// overlay, named from the iframe title (fallback "Sign up offer"); (2) background not hidden from AT ->
// `inert` every other `document.body` child while open, cleared on close/hide/removal and on `pagehide`
// (a stuck `inert` bricks the page); (3) transparent-interceptor guard -> whenever the creative is NOT
// visibly open (removed / display:none / zero-height / visibility:hidden) block pointer events on the
// overlay + iframe via `.a11y-3p-overlay-pointer-off` so an invisible full-viewport iframe can never eat
// taps, restoring them when it opens. We deliberately do NOT synthesize Escape-to-close or force-hide the
// popup while open (vendor state-desync risk), do NOT touch `body`/`html` overflow (the vendor manages the
// scroll lock), and do NOT patch inside the cross-origin creative (creatives.attn.tv is unreachable).
//
// TYDAL / Rivo ba-widget (DORMANT today, `widgets_config.active:false`; may return with one vendor toggle):
// container `[id^="ba-widget-"][id$="-container"].ba-widget-namespace` holds `#ba-widget-iframe`
// (src `about:blank`, sandboxed, untitled). SAFE subset always applied when the iframe exists: title it
// "Sign up offer" (it ships with none). The iframe content is not readable cross-frame, so "open" cannot be
// read from inside it; however the audit snapshots show the widget renders NOTHING while dormant and REMOVES
// the container entirely on close, so the ONLY observed rendered state is the full-viewport popup. We
// therefore key "open" on an observable main-page signal: container present + not display:none + iframe
// visible and covering >= 50% of each viewport axis. In that state we apply the same dialog semantics +
// background `inert` as Attentive; in every other state (dormant sticky/transparent interceptor) we block
// pointer events. We do NOT guess an in-iframe open/close branch we cannot key on evidence.
//
// VENDOR-FRAGILITY CAVEAT: these are post-render host-side patches on vendor-owned nodes, ids, and classes.
// A vendor update can rename or restructure them and silently disable every guard below at any time; all
// selectors are null-guarded so the code is a no-op when neither vendor is present. WCAG 2.2 1.3.2 Meaningful
// Sequence (A) [background inert / reading order], 2.1.1 Keyboard (A) [tap-jail guard], 2.4.3 Focus Order (A)
// [background inert], 4.1.2 Name, Role, Value (A) [dialog role/name, iframe title].
(function initThirdPartyOverlayA11yGuards() {
  if (typeof document === 'undefined' || typeof window === 'undefined') {
    return;
  }

  var POINTER_OFF_CLASS = 'a11y-3p-overlay-pointer-off';
  var MANAGED_ATTR = 'data-a11y-3p-managed';
  // Set by the fail-open failsafe below: once a misapplied inert has been detected on this page, never
  // re-apply inert for the rest of the page life (prevents a click-release/re-freeze tug-of-war while
  // still keeping the harmless dialog semantics). Resets naturally on navigation.
  var inertLatchedOff = false;

  function isRendered(el) {
    if (!el || !el.isConnected) {
      return false;
    }
    var cs = window.getComputedStyle(el);
    if (!cs || cs.display === 'none' || cs.visibility === 'hidden') {
      return false;
    }
    var rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  // Resolve the element that IS the direct child of document.body for this overlay, so the inert sweep can
  // exclude that whole subtree (inert inherits; inerting an ancestor would disable the open popup itself).
  function bodyChildAncestorOf(el) {
    var node = el;
    while (node.parentElement && node.parentElement !== document.body) {
      node = node.parentElement;
    }
    return node.parentElement ? node : null;
  }

  function setPointerBlocked(el, blocked) {
    if (!el || !el.classList) {
      return;
    }
    if (blocked) {
      el.classList.add(POINTER_OFF_CLASS);
    } else {
      el.classList.remove(POINTER_OFF_CLASS);
    }
  }

  function makeGuard(cfg) {
    var debounceTimer = null;

    function setInert(overlay) {
      if (inertLatchedOff) {
        return;
      }
      var keep = bodyChildAncestorOf(overlay);
      if (!keep) {
        // Overlay detached from the document (mid-move/removal): do nothing rather than risk a stuck inert.
        return;
      }
      var children = document.body.children;
      for (var i = 0; i < children.length; i++) {
        var child = children[i];
        if (child === keep) {
          // The overlay's own subtree must never stay inert (e.g. a prior sweep marked it before it opened).
          if (child.hasAttribute('inert')) {
            child.removeAttribute('inert');
          }
          if (child.hasAttribute(cfg.mark)) {
            child.removeAttribute(cfg.mark);
          }
          continue;
        }
        if (child.hasAttribute(cfg.mark)) {
          continue;
        }
        child.setAttribute(cfg.mark, '');
        child.setAttribute('inert', '');
      }
    }

    function clearInert() {
      var marked = document.querySelectorAll('[' + cfg.mark + ']');
      for (var i = 0; i < marked.length; i++) {
        marked[i].removeAttribute('inert');
        marked[i].removeAttribute(cfg.mark);
      }
    }

    function applyOpen(overlay, interceptor) {
      if (overlay.getAttribute('role') !== 'dialog') {
        overlay.setAttribute('role', 'dialog');
      }
      if (overlay.getAttribute('aria-modal') !== 'true') {
        overlay.setAttribute('aria-modal', 'true');
      }
      var label = cfg.getLabel(overlay, interceptor);
      if (label && overlay.getAttribute('aria-label') !== label) {
        overlay.setAttribute('aria-label', label);
      }
      if (!overlay.hasAttribute(MANAGED_ATTR)) {
        overlay.setAttribute(MANAGED_ATTR, '');
      }
      setPointerBlocked(overlay, false);
      setPointerBlocked(interceptor, false);
      setInert(overlay);
    }

    function applyClosed(overlay, interceptor) {
      // Only strip dialog semantics WE added (never clobber a vendor-set name/role).
      if (overlay.hasAttribute(MANAGED_ATTR)) {
        overlay.removeAttribute('role');
        overlay.removeAttribute('aria-modal');
        overlay.removeAttribute('aria-label');
        overlay.removeAttribute(MANAGED_ATTR);
      }
      clearInert();
      // Transparent-interceptor / tap-jail guard: neutralize the invisible full-viewport layer.
      // Accessibility remediation: 2026-07-09 - now opt-in per vendor (cfg.blockWhenClosed). Blocking
      // every non-open state broke vendors with legitimate small-footprint states (Attentive's teaser
      // bubble); only vendors with an EVIDENCED invisible-blocker state (Tydal tap-jail) keep it.
      if (cfg.blockWhenClosed !== false) {
        setPointerBlocked(overlay, true);
        setPointerBlocked(interceptor, true);
      } else {
        setPointerBlocked(overlay, false);
        setPointerBlocked(interceptor, false);
      }
    }

    function sync() {
      debounceTimer = null;
      var overlay = cfg.getOverlay();
      var interceptor = cfg.getInterceptor();
      // Always-safe idle fixes (e.g. titling the untitled Tydal iframe) regardless of open state.
      if (cfg.applyIdleFixes) {
        cfg.applyIdleFixes(overlay, interceptor);
      }
      if (!overlay) {
        // Vendor absent (or removed on close): ensure no stale inert survives, then no-op.
        clearInert();
        return;
      }
      if (cfg.isOpen(overlay, interceptor)) {
        applyOpen(overlay, interceptor);
      } else {
        applyClosed(overlay, interceptor);
      }
    }

    function schedule() {
      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }
      debounceTimer = setTimeout(sync, 60);
    }

    function bindOverlayObserver() {
      var overlay = cfg.getOverlay();
      if (!overlay || overlay.getAttribute('data-a11y-3p-obs') === '1') {
        return;
      }
      overlay.setAttribute('data-a11y-3p-obs', '1');
      // The documentElement observer below only watches childList (overlay added/removed); an attribute
      // observer here catches the vendor flipping the iframe's style/display/visibility/title in place.
      new MutationObserver(schedule).observe(overlay, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class', 'hidden', 'aria-hidden', 'title']
      });
    }

    return {
      schedule: schedule,
      bindOverlayObserver: bindOverlayObserver,
      clearInert: clearInert
    };
  }

  var guards = [
    makeGuard({
      mark: 'data-a11y-attn-inert-sibling',
      getOverlay: function () {
        return document.getElementById('attentive_overlay');
      },
      getInterceptor: function () {
        return document.getElementById('attentive_creative');
      },
      isOpen: function (overlay, interceptor) {
        // Accessibility remediation: live-incident fix 2026-07-09. Attentive has THREE lifecycle states,
        // not two: the full-viewport popup (fresh session, ~100% of the viewport), REMOVED (after
        // dismiss), and a small teaser bubble (~186x60, bottom corner) that frequency-capped RETURNING
        // visitors get on reload. The original check ("iframe rendered with a box") classified the
        // teaser as an open modal and inerted the whole page behind a corner pill - the intermittent
        // site-freeze the client hit when publishing (fresh test sessions never see the teaser, which
        // is why it escaped every pre-ship pass). Only the full-coverage state is a modal: require the
        // creative to cover >=50% of BOTH viewport axes (the same rule the Tydal guard below already
        // used). The teaser falls through to the closed branch, which must leave it fully interactive.
        if (!isRendered(interceptor)) {
          return false;
        }
        var rect = interceptor.getBoundingClientRect();
        return (
          rect.height >= window.innerHeight * 0.5 && rect.width >= window.innerWidth * 0.5
        );
      },
      // Accessibility remediation: never pointer-block Attentive's non-open states. The teaser bubble is
      // legitimate interactive vendor UI (its iframe box IS the pill, so nothing outside it is covered),
      // and the dismissed state removes the nodes entirely - there is no verified invisible-blocker
      // state left to guard against (the 2026-07-08 "invisible blocker" observation was the genuinely
      // open popup on a fresh automation session).
      blockWhenClosed: false,
      getLabel: function (overlay, interceptor) {
        // Accessibility remediation: name the dialog to MATCH ITS VISIBLE TITLE (client-reviewed
        // 2026-07-08). The creative's on-screen headline is "UNLOCK 10% OFF YOUR FIRST ORDER"; the
        // vendor iframe title ("Sign Up via Text for Offers") does not match what sighted VoiceOver/
        // braille users see, which is confusing even though a non-visible dialog name is not itself a
        // WCAG A/AA failure. The headline lives in the cross-origin creative and cannot be read at
        // runtime, so it is mirrored here as a constant - UPDATE THIS STRING if marketing edits the
        // Attentive creative headline (same vendor-fragility caveat as the rest of this block).
        var VISIBLE_HEADLINE = 'Unlock 10% off your first order';
        if (VISIBLE_HEADLINE) {
          return VISIBLE_HEADLINE;
        }
        var title = interceptor ? (interceptor.getAttribute('title') || '').trim() : '';
        return title || 'Sign up offer';
      },
      applyIdleFixes: null
    }),
    makeGuard({
      mark: 'data-a11y-tydal-inert-sibling',
      getOverlay: function () {
        return (
          document.querySelector('[id^="ba-widget-"][id$="-container"].ba-widget-namespace') ||
          document.querySelector('[id^="ba-widget-"][id$="-container"]')
        );
      },
      getInterceptor: function () {
        return document.getElementById('ba-widget-iframe');
      },
      isOpen: function (overlay, interceptor) {
        // Cross-frame content is unreadable; the audit shows the dormant widget renders nothing and close
        // removes the container, so the only observed rendered state is the full-viewport popup. Treat a
        // displayed container plus a visible iframe covering >=50% of each viewport axis as open.
        if (!isRendered(overlay) || !isRendered(interceptor)) {
          return false;
        }
        var rect = interceptor.getBoundingClientRect();
        return (
          rect.height >= window.innerHeight * 0.5 && rect.width >= window.innerWidth * 0.5
        );
      },
      getLabel: function () {
        return 'Sign up offer';
      },
      applyIdleFixes: function (overlay, interceptor) {
        if (interceptor && !(interceptor.getAttribute('title') || '').trim()) {
          interceptor.setAttribute('title', 'Sign up offer');
        }
      }
    })
  ];

  function syncAll() {
    for (var i = 0; i < guards.length; i++) {
      guards[i].bindOverlayObserver();
      guards[i].schedule();
    }
  }

  function clearAllInert() {
    for (var i = 0; i < guards.length; i++) {
      guards[i].clearInert();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }
  // Catch the vendor overlays being injected/removed after load (both are appended by async vendor scripts).
  new MutationObserver(syncAll).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
  // Vendors can add/hide the creative while the tab is backgrounded; re-check on return.
  document.addEventListener('visibilitychange', syncAll);
  // Safety net: never leave the page inert across a navigation / bfcache restore.
  window.addEventListener('pagehide', clearAllInert);
  // Accessibility remediation: 2026-07-09 fail-open failsafe. If OUR inert marks are active and a user's
  // pointer/keyboard input lands on <body>/<html> (the hit-test fell through everything - the signature
  // of a page frozen by a misapplied inert, since inert subtrees receive no events), the classification
  // must be wrong: release everything immediately and re-sync. In a LEGITIMATE modal state this never
  // fires (input lands on the popup/overlay, which is never inert). Converts any future vendor state we
  // have not seen from a stuck page into a self-healing first-tap recovery.
  function failOpenIfFrozen(e) {
    var t = e.target;
    if (t !== document.body && t !== document.documentElement) {
      return;
    }
    if (!document.querySelector('[data-a11y-attn-inert-sibling], [data-a11y-tydal-inert-sibling]')) {
      return;
    }
    inertLatchedOff = true;
    clearAllInert();
    syncAll();
  }
  document.addEventListener('pointerdown', failOpenIfFrozen, true);
  document.addEventListener('keydown', failOpenIfFrozen, true);
})();
